export default {
	Crud: {
		Create: "Criar",
		Read: "Leitura",
		Update: "Atualizar",
		Delete: "Excluir",
		List: "Lista",
		Additionals: "Adicionais",
		Modules: "Módulos",
	},
	NotPermissionPage: {
		NotPermissions: "Você não tem permissão para esta opção!",
		NotPermissionsText: "Entre em contato com o administrador da plataforma para obter permissão.",
		NotPermissionPlatform: "Você não tem permissão para acessar esta plataforma",
	},
	NotAuthorizedPage: {
		Title: "Você não está autorizado",
		Subtitle: "Entre em contato com o administrador, se você deseja acessar.",
		SubtitleDatarutas:
			"Para poder selecionar pontos de passagem a partir de rotas de dados, é necessário iniciar sessão na sua conta.",
		SubtitleResourceDatarutas:
			"Para poder selecionar recursos a partir de datarutas, é necessário, em primeiro lugar, iniciar sessão na sua conta.",
		ButtonText: "De volta ao roteador.",
		LogOut: "Sair",
		CompanyOperatingRange: "As datas fechadas de funcionamento da empresa estão fora do rango permitido.",
	},
	DefinesHowTheSelectedRoutesWill:
		"Define como as rotas selecionadas serão agendadas no Datarutas. Pode ser Padrão, com um ponto de início e um destino final sem paradas intermediárias, ou Com Pontos de Parada, onde são incluídos pontos de interesse a serem visitados antes do destino para entregas ou coletas.",
	ListOfSchedules: "Lista de Agendas",
	SelectSchedule: "Selecionar Agenda",
	ListSchedules: "Listar Agendas",
	Manage: "Gerenciar",
	IncludeDeposits: "Incluir depósitos na exportação",
	Standard: "Padrão",
	WithWaypoints: "Com waypoints",
	Waypoint: "Waypoint",
	In: "em",
	TypeOfSchedule: "Tipo de cronograma",
	RouteId: "Rota Id",
	FileName: "Nome do arquivo",
	OnlyAMaximumOf3VisitPoints:
		" Só é permitido um máximo de 3 pontos de visita para o serviço de recolha. Remova qualquer um dos pontos selecionados para continuar.",
	ThereAreNoVisitPointsAvailable:
		"Não existem pontos de entrega disponíveis para o serviço de recolha. Acrescente-os primeiro utilizando a opção correspondente em",
	Cost: "Custo",
	Points: "Pontos",
	LimitvsServiceConsumption: "Uso vs Limite",
	Last1Day: "Último dia",
	Last7Days: "Últimos 7 dias",
	LastMonth: "Último mês",
	ConsumptionPerService: "Consumo por serviço",
	Totalconsumption: "Consumo total",
	TotalSubscriptionMonthly: "Por assinatura mensal",
	RoutingService: "Encaminhamento",
	Matrix: "Matriz",
	MapMatching: "Correspondência de Mapas",
	Isochrones: "Isócronas",
	FieldsWithTheIndicatedIconsAreCompatible:
		"Os campos com os ícones indicados são compatíveis com certos roteadores. Certifique-se de preencher essas informações se planeja usá-los",
	RoadNetworkWithSouthAmerican:
		"Rede viária com países da América do Sul, como: Argentina, Bolívia, Brasil, Chile, Colômbia, Equador, Guiana, Paraguai, Peru, Suriname, Uruguai e Venezuela.",
	ViewMeshesAndTheirStatus: "Ver malhas e seus estados",
	Pending: "Pendente",
	Available: "Disponível",
	NotAvailable: "Não disponível",
	RepetitionsHaveBeenGeneratedCorrectly: "Os replays foram gerados corretamente",
	DeleteAssignment: "Remover atribuição",
	AddRepeatFormatAndTimeWindow: "Adicionar formato de repetição e janela de tempo",
	ViewRepetitionFormatAndTimeWindow: "Visualizar o formato de repetição e a janela de tempo atribuída",
	Generate: "Gerar",
	GenerationOfRepetitions: "Geração de repetições",
	RepeatFormat: "Formato de repetição",
	NoGroupAssigned: "Nenhum grupo atribuído",
	GroupSearch: "Grupo",
	ExpandAll: "Expandir tudo",
	CollapseEverything: "Colapso de tudo",
	DurationRefersToTheTotalTimeTaken:
		"Duração refere-se ao tempo total necessário para realizar uma atividade ou processo do início ao fim, expresso em horas. Simplificando, é o período de tempo que passa enquanto uma tarefa é realizada. Se desejar expressar a duração em dias, deve ser convertida para horas (por exemplo, 1 dia equivale a 24 horas).",
	WithoutOriginIdentification: "Sem identificação de origem",
	IdentificationOfOrigin: "Identificação da origem",
	IdentificationOfOriginText:
		"Campo para agrupar veículos com a mesma identificação de origem, facilitando a criação de vários itinerários para o mesmo veículo. Este campo não é único nem obrigatório, o que significa que vários veículos podem ter o mesmo ID de origem.",
	IdentificationOfOriginVisitPointText:
		"Campo para agrupar os pontos de visita sob o mesmo ID de origem, facilitando a criação de vários itinerários para o mesmo ponto de visita. Este campo não é único nem obrigatório, o que significa que vários pontos de visita podem ter o mesmo ID de origem.",
	ChooseOneOrMoreOfTheseObjectivesToCustomize:
		"Pode escolher um ou mais destes objectivos para personalizar a otimização de acordo com as suas necessidades comerciais, garantindo a máxima eficiência e melhorando os resultados do planeamento logístico.",
	BasicObjectives: "Objetivos básicos",
	OptimizationObjectives: "Objetivos de otimização",
	SelectBasicOrAdvancedObjectives: "Selecione os objetivos básicos ou avançados para a otimização",
	MinimizeUnassigned: "Minimizar paradas não atribuídas",
	MinimizeCost: "Minimizar custos",
	MinimizeDistance: "Minimizar distâncias",
	MinimizeDuration: "Minimizar duração",
	MinimizeTourCount: "Minimizar número de rotas",
	MaximizeTourCount: "Maximizar número de rotas",
	MinimizeTravelDuration: "Minimizar duração de viagem",
	MaximumDistance: "Distância máxima",
	MaximumDiameter: "Diâmetro máximo",
	MaximumDistanceClusterText:
		"Define a distância máxima (em metros) entre uma recolha/entrega e o seu vizinho mais próximo no cluster. Se uma recolha/entrega estiver a esta distância de outra recolha/entrega, o algoritmo pode considerar estas recolhas/entregas como fazendo parte do mesmo cluster. A gama de valores disponíveis para este parâmetro é de 0 a 75",
	MaximumDiameterClusterText:
		"Distância máxima permitida entre quaisquer duas recolhas/entregas no agrupamento, em metros. Isto assegura que o cluster não se torne demasiado grande em diâmetro, mesmo que os pickups/entregas individuais estejam suficientemente próximos uns dos outros. A gama de valores disponíveis para este parâmetro é de 0 a 1000",
	ClusteredRouteParametersText:
		"No planeamento de viagens, o agrupamento de trabalhos geograficamente próximos numa única paragem cria percursos mais eficientes, reduzindo o tempo de viagem e minimizando o consumo de combustível. A redução do tempo de condução permite a conclusão de mais trabalhos e pode aumentar o número de trabalhos concluídos num turno",
	ClusteredRouteParameters: "Parâmetros de rota agrupada",
	NoRoutingParametersAssigned: "Nenhum parâmetro de encaminhamento atribuído",
	Meters: "Metros",
	Initial: "Inicial",
	End: "Final",
	Penalty: "Penalização",
	ByAnticipation: "Antecipadamente",
	ForTardiness: "Por atraso",
	TheStartDateMust: "A data de início deve estar dentro da janela horária",
	TheEndDateMust: "A data final deve estar dentro da janela horária",
	TheStartTimeMust: "A hora de início deve estar dentro da janela horária",
	TheEndTimeMust: "A hora final deve estar dentro da janela horária",
	OptimizationGroup: "Grupo de Otimização",
	ControlPanel: "Painel de controlo",
	IfYouExitNowAndYouHaveUnsavedData:
		"Se sair agora e tiver dados não guardados, perderá todo o progresso que fez. Tem a certeza de que pretende continuar?",
	NotSpecified: "Não especificado",
	NoneOfTheAbove: "Nenhuma das anteriores",
	ValidatingTheInformationProvided: "Validação das informações fornecidas...",
	LoadingVisitPoints: "Carregar pontos de visita",
	MaxSelectedResourcesReached: "Seleção máxima de recursos alcançada",
	ValidateField: "O campo {n} é obrigatório",
	ThereIsNoDataToDisplayPleaseTryToAddNewRecords: "Não existem dados para apresentar. Tente adicionar novos registos",
	NoResultsWereFoundForYourSearch: "Não foram encontrados resultados para a sua pesquisa",
	UserRecordWithId: "Registo de utilizador com id",
	NotFound: "não encontrado",
	Or: "O",
	AllowedFileExtensions: "Extensões de arquivos permitidas",
	DropFile: "Drop file",
	RealTimeTrafficData: "Ter em conta o tráfego em tempo real no cálculo dos itinerários",
	RealTimeTrafficDataText:
		"Esta opción permite que la optimización tenga en cuenta las condiciones actuales del tráfico, como cierres de carreteras, accidentes y tráfico intenso",
	TheMaximumFileSelectionForVehiclesHasBeenReached: "A seleção máxima de arquivos para veículos foi atingida",
	VisitingPointsWereSuccessfullyAdded: "Os pontos de visita foram adicionados com sucesso",
	VehiclesWereSuccessfullyAdded: "Os veículos foram adicionados com sucesso",
	TheMaximumFileSelectionPickup: "Foi atingida a seleção máxima de arquivos para o serviço de levantamento",
	TheMaximumFileSelectionDelivery: "Foi atingida a seleção máxima de arquivos para o serviço de entrega",
	PickupPoints: "Pontos de coleta",
	DeliveryPoints: "Pontos de entrega",
	AllowedVehicleFiles: "Arquivos de veículos permitidos",
	AllowedPickupfiles: "Arquivos de coleta permitidos",
	AllowedDeliveryFiles: "Arquivos de entrega permitidos",
	AddVehicleStatistics: "Adicionar estatísticas",
	DeterminesPageStatistics: "Determina se deve ser adicionada uma página com estatísticas gerais do veículo",
	RestoringOrder: "Restabelecimento da ordem",
	SortAndSelectTheFieldsToBeExported:
		"Ordene os campos arrastando e largando seleccione todos ou alguns deles para exportação",
	ManageFields: "Gerir campos",
	VehiclesUpdatedCorrectly: "Veículos corretamente actualizados",
	VisitingPointsCorrectlyUpdated: "Pontos de visita corretamente actualizados",
	UpdatingVisitPointsByUploadingFiles: "Atualização dos pontos de visita através do carregamento de arquivos",
	UpdatingVehiclesByFileUpload: "Atualização de veículos através do carregamento de arquivos",
	UserHasAFileUploadProcessInPlace:
		"O Sr. Utilizador tem um processo de carregamento de arquivos em vigor.¿tem a certeza de que pretende abandoná-lo?",
	YouWishToLeaveEven: "¿Deseja partir mesmo na ausência de visitas de correção?",
	ToAssignAVisitPoint: "Para atribuir um ponto de visita, é necessário que lhe seja atribuído um recurso",
	ToAssignAnActivity: "To assign an activity, they must have a resource assigned to them",
	ToAssignAnActivityOrVisitPoint:
		"Para atribuir uma atividade ou um ponto de visita, as visitas devem ter um recurso atribuído",
	Visit: "Visita",
	VisitsWithErrors: "Visitas com erros ",
	SearchResourceBy: "Recurso de pesquisa por",
	SearchVisitPointBy: "Procurar ponto de visita por",
	Unlimited: "Ilimitado",
	Identification: "Identificação",
	EndDeposit: "Depósito Final",
	StartDeposit: "Depósito inicial",
	TeamsTable: "Equipas",
	SkillsTable: "Competências",
	Capabilities: "Capacidades",
	SpecifyTheTypeOfServiceForTheSelectedVisitPoints:
		"Especifique o tipo de serviço para os pontos de visita seleccionados",
	ApiKey: "Chave da API",
	RoutingNotification: "Ruteados",
	RoutingNotNotification: "Não roteado",
	GoTo: "Ir para",
	ViewMore: "Ver mais",
	CopiedTextErrors: "Dados copiados para a área de transferência com sucesso",
	ErrorInCopying: "Erro ao copiar",
	Errors: "Erros",
	Go: "Ir",
	Default: "Predefinição",
	Undo: "Desfazer",
	ClickHereToVerify: "Clique aqui para verificar o status do roteiro",
	Duplicate: "Duplicado",
	Options: "Opções",
	Label: "Rótulo",
	TypeLabel: "Rótulo de tipo",
	Basics: "Básico",
	ExportAll: "Exportar Tudo",
	Return: "Retornar",
	AcceptsNumbersAndTheDashSign:
		"Insira um formato válido para o nome, lembrando que ele só aceita números, letras e sublinhados",
	See: "Ver",
	DeliveryService: "Serviço de entrega",
	PickUpService: "Pegar serviço",
	ShippingTypeDelivery: "Tipo de envio entrega",
	PickupShippingType: "Tipo de envio de coleta",
	Selected: "Selecionado",
	RemoveSelection: "Remover seleção",
	ClearSelection: "Limpar seleção",
	ShowSelected: "Mostrar selecionado",
	AssignTheCapacitiesFileUploadRouting: "Atribuir as capacidades que serão usadas para roteiro de upload de arquivo",
	AssignTheCapacitiesOptimizationRouting: "Atribui as capacidades que serão utilizadas para roteiro por otimização",
	CreationDate: "Data de criação",
	Of: "de",
	For: "para",
	SearchSeparatedByCommas: "Pesquisar vários resultados inserindo dados separados por vírgulas",
	Apply: "Aplicar",
	DELIVERY: "Entrega",
	PICKUP: "Coletar",
	TypeOfService: "Tipo de serviço",
	SelectAdditionalField: "Selecione campo adicional",
	NoResultsFoundFor: "Nenhum resultado encontrado para",
	NoResultsFound: "Nenhum resultado encontrado",
	Filters: "Filtros",
	NotAdditionalFields: "O objeto não tem campos adicionais",
	LocationInformation: "Informações de localização",
	SeeDetailedInformation: "Ver informações detalhadas",
	PlatformStart: "Início da plataforma",
	Check: "Verificando",
	Value: "Valor",
	TagValue: "Valor da etiqueta",
	LabelHelp: "Nome visível no formulário",
	PropertyDefinition: "Definição de propriedade",
	AdditionalFields: "Campos Adicionais",
	Priority: "Prioridade",
	SelectInitTime: "Selecione a hora inicial",
	SelectEndTime: "Selecione o horário de término",
	Refresh: "Atualizar",
	SearchBy: "Procurar por",
	NoDataAvailable: "Sem dados disponíveis",
	ErrorTitle: "Um erro ocorreu",
	ErrorMessage: "An error occurred. Please try again!",
	Minimize: "Minimizar",
	Maximize: "Maximizar",
	To: "para",
	ViewInPopup: "Ver em pop-up",
	LogOut: "Sair",
	Schedule: "Cronograma",
	All: "Tudo",
	Activities: "Atividades",
	Address: "Endereço",
	AddedOn: "Adicionado",
	Back: "Voltar",
	CurrentPosition: "Posição atual",
	Modules: "Módulos",
	Configuration: "Configuração",
	Accept: "Aceitar",
	Cancel: "Cancelar",
	Country: "País",
	City: "Cidade",
	Department: "Departamento / Província / Estado / Região",
	Province: "Província",
	Region: "Região",
	State: "Estado",
	Canton: "Cantão",
	Municipality: "Município",
	District: "Distrito",
	Commune: "Comuna",
	Name: "Nome",
	Description: "Descrição",
	Warning: "Aviso",
	Information: "Informação",
	GeneralInformation: "Informações gerais",
	Dashboard: "Painel",
	eCommerce: "Comércio eletrônico",
	Apps: "Apps",
	Todo: "Tudo",
	Chat: "Chat",
	Email: "E-mail",
	Username: "Nome do usuário",
	Calendar: "Calendário",
	Format: "Formato",
	FullCalendar: "Calendário Completo",
	SimpleCalendar: "Calendário Simples",
	Shop: "Loja",
	ItemDetails: "Detalhes do item",
	Cart: "Carrinho",
	WishList: "Lista de Desejos",
	Checkout: "Check-out",
	UI: "UI",
	DataList: "Lista de Dados",
	ListView: "Exibição de lista",
	ThumbView: "Visualização do polegar",
	Grid: "Rede",
	Vuexy: "Vuexy",
	Vuesax: "Vuesax",
	Tailwind: "Tailwind",
	Colors: "Cores",
	Card: "Cartão",
	Basic: "Básico",
	Statistics: "Estatisticas",
	Analytics: "Analytics",
	CardActions: "Ações do cartão",
	CardColors: "Cores do cartão",
	Table: "Mesa",
	agGridTable: "agGrid Table",
	Components: "Componentes",
	Alert: "Alerta",
	Avatar: "Avatar",
	Badge: "Distintivo",
	Breadcrumb: "Migalhas de pão",
	Button: "Botão",
	ButtonGroup: "Grupo de Botão",
	Chip: "Chip",
	Collapse: "Colapso",
	Dialogs: "Diálogos",
	Divider: "Divisor",
	DropDown: "Lista desdobravel",
	List: "Lista",
	Loading: "Carregando...",
	Navbar: "Navbar",
	Notifications: "Notificações",
	Notification: {
		MarKAllRead: "Marcar tudo como lido",
		NewNotifications1: "Novo",
		NewNotifications2: "Notificações",
		Notification: "Notificação",
		Notifications: "Notificações",
		DeleteAllNotifications: "Eliminar todas as notificações",
		UPLOAD_FILE: "Notificações sobre o upload do arquivo",
		DOWNLOAD_FILE: "Notificações sobre o download do arquivo",
		CREATE_OPTIMIZATION: "Notificações de novas optimizações",
		EVENT: "Notificações sobre o calendário",
		New: "Nova",
		NewNotification: "Novas Notificações",
		AppNotifications: "Notificações de aplicativo",
		NEW_EVENT: "NOVO EVENTO",
		EVENT_NOT_ASSIGNED: "EVENTO NÃO ATRIBUÍDO",
		RESCHEDULED_EVENT: "EVENTO REAGENDADO",
		EVENT_IN_PROCESS: "EVENTO EM PROCESSO",
		EVENT_ENDED: "EVENTO ENCERRADO",
		EVENT_CANCELLED: "EVENTO CANCELADO",
		EVENT_ON_THE_WAY: "A CAMINHO DA VISITA",
		EVENT_DELAYED: "DEMORANDO PARA VISITAR",
		FINALIZED: "PROCESSO FINALIZADO",
		ERRORINFILE: "ERRO NO FICHEIRO",
		LOADED: "ARQUIVO CARREGADO",
		PROCESS: "ARQUIVO ESTÁ EM PROCESSO",
		DOWNLOAD_FINALIZED: "Download Concluído",
		PANIC_ALARM: "Alarme de pânico",
		PanicAlarmText: "Um alarme de pânico foi relatado por um dos recursos no campo",
		CheckOut: "Verificar",
		UPLOAD_FILE_PV: "Upload de pontos de visitas",
		UPLOAD_FILE_OP: "Carregar ficheiro de optimizações",
		DONE_OP: "Otimização completa",
		PROCESSINGOPTIMIZATION: "OPTIMIZAÇÃO DO PROCESSAMENTO",
		OPTIMIZATIONERROR: "ERRO DE OPTIMIZAÇÃO",
		NewNotificationGlobal: {
			Title: "Novas notificações de rotas concluídas",
			Text: "Você completou novas rotas, veja seu painel de notificação",
		},
	},
	Pagination: "Paginação",
	Popup: "Popup",
	Progress: "Progresso",
	Sidebar: "Barra Lateral",
	Slider: "Slider",
	Tabs: "Abas",
	Tooltip: "Mensagem de ajuda",
	Upload: "Envio",
	FormsAndTable: "Formulários e mesa",
	FormElements: "Elementos do Formulário",
	Select: "Selecione",
	SelectAll: "Selecionar tudo",
	Submit: "Enviar",
	Switch: "Trocar",
	Checkbox: "Caixa de seleção",
	Required: "Obrigatório",
	Radio: "Rádio",
	Input: "Entrada",
	NumberInput: "Número de entrada",
	Textarea: "Textarea",
	FormLayouts: "Layouts de formulário",
	FormWizard: "Assistente de Formulários",
	FormValidation: "Validação de Formulário",
	FormInputGroup: "Grupo de entrada do formulário",
	Pages: "Páginas",
	ItemsPerPages: "Itens por páginas",
	Authentication: "Autenticação",
	Register: "Registrar",
	ForgotPassword: "Esqueceu sua senha",
	LockScreen: "Tela de bloqueio",
	Miscellaneous: "Diversos",
	ComingSoon: "Em breve",
	Success: "Sucesso",
	Error: "Erro",
	404: "404",
	500: "500",
	NotAuthorized: "Não autorizado",
	Maintenance: "Manutenção",
	Profile: "Perfil",
	User: "Usuário",
	View: "Visualizar",
	UserSettings: "Configurações do Usuário",
	ListOfUsers: "Lista de usuário",
	CreateUser: "Criar usuário",
	UpdateUser: "Atualizar usuário",
	ViewUser: "Ver usuário",
	CompanySettings: "Configurações da empresa",
	Invoice: "Fatura",
	FAQ: "FAQ",
	Search: "Procurar",
	KnowledgeBase: "Base de Conhecimento",
	ChartsAndMaps: "Gráficos e mapas",
	Charts: "Gráficas",
	ApexCharts: "Apex Charts",
	chartjs: "chartjs",
	echarts: "echarts",
	chartist: "chartist",
	GoogleMap: "Google Map",
	Extensions: "Extensões",
	QuillEditor: "Quill Editor",
	DragAndDrop: "Arraste e solte",
	Datepicker: "Selecionador de Data",
	DatetimePicker: "Selecionador de data e hora",
	AccessControl: "Controle de acesso",
	I18n: "I18n",
	Languages: {
		Languages: "Línguas",
		Language: "Língua",
		Spanish: "Espanhol",
		English: "Inglês",
		Portuguese: "Português",
	},
	Carousel: "Carrossel",
	Clipboard: "Clipboard",
	ContextMenu: "Menu contextual",
	StarRatings: "Avaliações de estrelas",
	Autocomplete: "Autocompletar",
	Tree: "Árvore",
	// "Import/Export": 'Import/Export',
	Import: "Importar",
	Export: "Exportar",
	ExportSelected: "Exportar selecionados",
	Others: "Outros",
	MenuLevels: "Níveis de Menu",
	MenuLevel2p1: "Nível de Menu 2.1",
	MenuLevel2p2: "Nível de Menu 2.2",
	MenuLevel3p1: "Nível de Menu 3.1",
	MenuLevel3p2: "Nível de Menu 3.2",
	DisabledMenu: "Menu Desabilitado",
	Support: "Suporte",
	Documentation: "Documentação",
	RaiseSupport: "Levante o Suporte",
	demoTitle: "Título do Cartão",
	demoText:
		"Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.",
	// Map Module
	Map: "Mapa",
	// Company Module
	Company: "Empresa",
	CompanyFormTitleCreate: "Formulário para criar uma nova empresa",
	CompanyFormTitleUpdate: "Formulário para atualizar uma empresa",
	NewCompany: "Nova Empresa",
	UpdateCompany: "Atualizar empresa",
	ListOfCompanies: "Lista de empresas",
	TitleConfirmCompanyCreate: "Empresa criada",
	TextConfirmCompanyCreate: "A empresa foi criada com sucesso",
	TitleConfirmCompanyDelete: "Empresa excluída",
	TextConfirmCompanyDelete: "A empresa selecionada foi excluída com sucesso",
	TitleConfirmCompanyUpdate: "Empresa atualizada",
	TextConfirmCompanyUpdate: "A empresa selecionada foi atualizada com sucesso",
	DeleteCompany: "Tem certeza de que deseja excluir esta empresa? Por favor aceite para continuar",
	Confirm: "Confirme",
	MissingFieldTitle: "Campos ausentes",
	MissingField: "Alguns campos estão faltando no formulário",
	CompanyCreate: {
		CompanyName: "Nome da empresa",
		Address: "Endereço",
		Phone: "Telefone",
		Nit: "NIT",
		InitDate: "Data de Inicialização",
		EndDate: "Data final",
		ContactPerson: "Pessoa de contato",
		Country: "País",
		City: "Cidade",
		Description: "Descrição",
		Create: "Criar",
		CreateFirstResourceAlert:
			"Agora é necessário criar o primeiro recurso para a administração da empresa. Por favor, preencha o formulário.",
	},
	CompanyModule: {
		Add: "Adicionar novo",
		ManagingCompanies: "Gestão de empresas",
		MissingServiceTime: "Tempo de serviço ausente",
		Month: "Mês",
		Year: "Ano",
		Day: "dia",
		Months: "Mêses",
		Years: "Anos",
		Days: "Dias",
		nameRequired: "O nome do campo é obrigatório",
		addressRequired: "O campo endereço é obrigatório",
		phoneRequired: "O telefone de campo é obrigatório",
		nitRequired: "O nit da empresa de campo é obrigatório",
		date_initRequired: "O campo data init é obrigatório",
		date_endRequired: "O campo data de término é obrigatório",
		contac_personsRequired: "O campo de contato de pessoas é obrigatório",
		cityRequired: "O campo cidade é obrigatório",
		countryRequired: "O país do campo é obrigatório",
		descriptionRequired: "A descrição do campo é obrigatória",
		InvalidFields: "Campos Inválidos",
		ChechInfo: "Verifique as informações, se estiverem corretas, clique no botão Salvar para finalizar o processo.",
		ViewCompanyList: "Clique aqui para ir para a lista de empresas",
		AdminResource: "Recurso de Administrador",
		AdminResourceSuccess: "O recurso de administrador foi criado com sucesso",
		AdminResourceError: "Recurso de administrador não pôde ser criado",
		AdminResourceFailed:
			"Algo deu errado durante a criação do recurso de administrador. tente criá-lo novamente a partir da lista de empresas.",
		DateInitError: "A data de início não pode ser posterior à data de término.",
		CompanyInformation: "Informações da Empresa",
		Summary: "Resumo",
		Finish: "Terminar",
		ActivateServiroutes: "Selecione o recurso de administrador para a ativação de ServiRotas.",
		ActivateSitidadaText1: "É necessário ativar o SITIDATA para o correto funcionamento da plataforma",
		ActivateSitidadaText2: "clique aqui para adicionar configuração.",
		RequiredConfig: "Configurações Requeridas",
		EmailAlreadyExist: "Já existe um usuário registrado com este e-mail",
		ValidEmail: "Email válido",
		ReleationShip: "Relacionamento com pontos de visita",
		Table: {
			Name: "Nome",
			Nit: "Nit",
			City: "Cidade",
			Address: "Endereço",
			Phone: "Telefone",
			Actions: "Ações",
			TotalResources: "Recursos",
			Configuration: "Configuração",
			Configurations: "Configurações",
		},
		Form: {
			ValidMessages: {
				Name: "O campo do nome da empresa é obrigatório",
				Address: "O campo de endereço é obrigatório",
				Phone: "O campo do telefone é obrigatório e deve ser numérico",
				Nit: "O campo nit é obrigatório",
				InitDate: "O campo de data de inicialização é obrigatório",
				EndDate: "O campo da data de término é obrigatório",
				ContactPerson: "O campo da pessoa de contato é obrigatório",
				Country: "O campo do país é obrigatório",
				City: "O campo da cidade é obrigatório",
			},
			Labels: {
				Create: "Criar",
				Update: "Atualizar",
				Cancel: "Cancelar",
			},
		},
	},
	// Breaks Module
	Breaks: "Pausas",
	AddBreak: "Adicionar pausa",
	ListOfBreaks: "Lista de Pausas",
	NewBreak: "Nova pausa",
	MinBreakDuration: "Duración mínima",
	SelectMinBreakDuration: "Seleccionar duración mínima",
	Break: "Pausa",
	TitleConfirmBreakCreate: "Pausa criada",
	TextConfirmBreakCreate: "A pausa foi criada com sucesso",
	TitleConfirmBreakDelete: "Pausa excluída",
	TextConfirmBreakDelete: "O intervalo selecionado foi excluído com sucesso",
	TitleConfirmBreakUpdate: "Break Atualizado",
	TextConfirmBreakUpdate: "O intervalo selecionado foi atualizado com sucesso",
	DeleteBreak: "Tem certeza que deseja deletar o intervalo?",
	CreateBreak: "Criar Pausa",
	UpdateBreak: "Pausa para atualização",
	visualizeBreak: "visualizar pausa",
	AssignedBreaks: "Pausas Atribuídas",
	NoAssignedBreaks: "Sem intervalos atribuídos",
	AssignBreaksTooltip: "Carregar a lista de pausas disponíveis para continuar",
	DeleteAllBreaks: "Eliminar todas as pausas.",
	ThereAreCurrentlyNoBreaksAvailable:
		"Atualmente, não existem pausas disponíveis na plataforma. Adicione uma nova utilizando o botão",
	BreakNotFound: {
		Title: "Descanso não encontrado",
		Text1: "registro de descanso com id:",
		Text2: "nao encontrado.",
	},
	BreakTable: {
		Name: "Nome",
		Description: "Descrição",
		StartHour: "Hora de início",
		EndHour: "Hora de Fim",
		AssignResources: "Recursos Atribuídos",
		Action: "Ações",
		Delete: "Excluir",
		Add: "Adicionar novo",
	},
	BreaksHour: "A hora de início não pode ser maior ou igual à hora de término.",
	BreakForm: {
		ValidMessages: {
			Name: "O campo nome é obrigatório",
			InitHour: "O campo de hora inicial é obrigatório",
			EndHour: "O campo da hora de término é obrigatório",
			InitHourEmpty: "A hora inicial não pode estar vazia",
		},
		ErrorMessages: {
			Error: "Erro",
			InitHourHeigh: "A hora inicial não pode ser maior na hora final",
			ValidInitHour: "A hora inicial não pode ser maior ou igual à hora final.",
			ValidEndHour: "O horário de término não pode ser menor ou igual ao horário de início.",
			DateInitError: "A data de início não pode ser posterior à data de término.",
		},
	},
	RemoveBreak: {
		Text1: "¿Tem certeza de que deseja remover a quebra?",
		Text2: "Aceite para continuar.",
	},
	// Skills Module
	Skills: {
		Skill: "Habilidade",
		Skills: "Habilidades",
		AddSkill: "Adicionar habilidade",
		ListOfSkills: "Lista de habilidades",
		NewSkill: "Nova habilidade",
		AssignedSkills: "Habilidades atribuídas",
		AssignSkill: "Atribuir habilidade",
		AssignSkills: "Atribuir habilidades",
		AssigneSkillTooltip: "Carregue a lista de habilidades disponíveis para continuar com a tarefa",
		NoAssignedSkills: "Nenhuma habilidade atribuída",
		TotalSkills: "Habilidades completas",
		NoSkillsAssigned: "Nenhuma habilidade atribuída",
		LoadListOfVehiclesSkills: "Carregar lista de veículos a atribuir a competências",
		TherAreCurrentlyNoSkillsAvailable:
			"There are currently no skills available on the platform. Add a new one using the option",
		Table: {
			Name: "Nome",
			Description: "Descrição",
			Identifier: "Identificador",
			Action: "Ações",
			Delete: "Excluir",
			Add: "Adicionar novo",
		},
		Messages: {
			Delete: "Tem certeza de que excluiu a habilidade? Por favor aceite para continuar",
			TitleConfirmDelete: "Habilidade Removida",
			TextConfirmDelete: "A habilidade selecionada foi excluída.",
			TitleConfirmCreate: "Habilidade Criada",
			TextConfirmCreate: "A habilidade foi criada com sucesso",
			TitleConfirmUpdate: "Habilidade atualizada",
			TextConfirmUpdate: "A habilidade foi atualizada com sucesso",
			DeleteAll: "Tem certeza de remover todas as habilidades da mesa?",
		},
		CreateSkill: "Criar Habilidade",
		UpdateSkill: "Atualizar habilidade",
		Form: {
			ValidMessages: {
				Name: "O campo nome é obrigatório",
				Identifier: "O campo identificador é obrigatório",
				Description: "O campo de descrição é obrigatório",
			},
		},
		DeleteSkill: {
			Text1: "Tem certeza de que excluiu a habilidade",
			Text2: "Aceitar para continuar.",
		},
	},
	// Capacity Module
	Capacity: {
		Capacity: "Capacidade",
		Capabilities: "Capacidades",
		CapabilityList: "Lista de capacidade",
		NewCapacity: "Nova capacidade",
		CreateCapacity: "Criar capacidade",
		UpdateCapacity: "Atualizar Capacidades",
		AddCapacity: "Adicionar capacidade",
		AssignedCapacities: "Capacidades atribuídas",
		AssignCapacity: "Alocar capacidade",
		AssignCapabilities: "Atribuir capacidades",
		NoAssignedCapability: "Sem capacidades atribuídas",
		AssigneCapacityTooltip: "Carregue a lista de capacidades disponíveis para continuar com a atribuição",
		TotalCapacities: "Capacidades totais",
		NoAssignedCapacities: "Sem capacidades atribuídas",
		ThereAreCurrentlyNoCapabilitiesAvailable:
			"Atualmente, não existem capacidades disponíveis na plataforma. Adicione uma nova capacidade utilizando o",
		MassiveActionsCapacities:
			"Esta opção permite atualizar massivamente os valores dos campos de demanda e tipo de serviço na lista de capacidades",
		Messages: {
			Delete: "Tem certeza de remover a capacidade? Aceite para continuar",
			TitleConfirmDelete: "Capacidade Removida",
			TextConfirmDelete: "A capacidade selecionada foi removida.",
			TitleConfirmCreate: "Capacidade Criada",
			TextConfirmCreate: "A capacidade foi criada com sucesso",
			TitleConfirmUpdate: "Capacidade Atualizada",
			TextConfirmUpdate: "A capacidade foi atualizada com sucesso",
			DeleteAll: "Tem certeza de remover todos os recursos da tabela?",
		},
		DeleteCapacity: {
			Text1: "¿Tem certeza de remover a capacidade",
			Text2: "Aceite para continuar.",
		},
	},
	// Teams Module
	Teams: {
		Team: "Equipe",
		WithoutTeam: "Sem equipe",
		Teams: "Equipes",
		AddTeam: "Adicionar equipe",
		ListOfTeams: "Lista de equipes",
		NewTeam: "Novo time",
		ThereAreCurrentlyNoWorkTeamsAvailable:
			"Atualmente, não existem equipas disponíveis na plataforma. Adicione uma nova equipa utilizando a opção",
		Table: {
			Name: "Nome",
			Description: "Descrição",
			Action: "Ações",
			Delete: "Excluir",
			Add: "Adicionar novo",
		},
		Form: {
			Label: "Rótulo",
			Name: "Nome",
			Type: "Modelo",
			Add: "Adicionar",
			ValidMessages: {
				Name: "O campo nome é obrigatório",
				Description: "O campo de descrição é obrigatório",
				AddProperty: "Preencha os campos para adicionar uma nova propriedade",
			},
		},
		Messages: {
			TitleConfirmCreate: "Equipe de trabalho criada.",
			TextConfirmCreate: "A equipe foi criada com sucesso",
			TitleConfirmDelete: "Equipe de trabalho eliminada",
			TextConfirmDelete: "A Força-Tarefa selecionada foi eliminada com sucesso",
			TitleConfirmUpdate: "Equipe de trabalho atualizada",
			TextConfirmUpdate: "A equipe de trabalho selecionada foi atualizada com sucesso",
			TextDelete: "Tem certeza de que deseja excluir a equipe de trabalho? Aceite para continuar.",
		},
		CreateTeam: "Criar Equipe",
		UpdateTeam: "Equipe de atualização",
	},
	// Deposits Module
	Deposits: {
		Depot: "Depósitos",
		Deposit: "Depósito",
		AddDeposit: "Adicionar depósito",
		ListOfDeposits: "Lista de Depósitos",
		NewDeposit: "Novo Depósito",
		CreateDeposit: "Criar Depósito",
		UpdateDeposit: "Depósito de atualização",
		NotFoundAddress: "O endereço inserido não foi encontrado no mapa, arraste o marcador para o endereço desejado",
		Table: {
			Name: "Nome",
			Description: "Descrição",
			Address: "Endereço",
			City: "Cidade",
			Action: "Ações",
			Delete: "Excluir",
			Add: "Adicionar novo",
		},
		Form: {
			Address: "Endereço",
			City: "Cidade",
			CX: "Coordenada X",
			CY: "Coordenada Y",
			Latitude: "Latitude",
			Longitude: "Longitude",
			StartAtDeposit: "Comece no depósito",
			EndAtDeposit: "Fim no depósito",
			EndDeposit: "Depósito Final",
			StartDeposit: "Depósito inicial",
			AddResource: "Adicionar Recurso",
			ValidMessages: {
				Name: "O campo nome é obrigatório",
				Description: "O campo de descrição é obrigatório",
				Country: "O país do país é obrigatório",
				Department: "O campo do Estado é obrigatório",
				City: "O campo da cidade é obrigatório",
				Address: "O campo de endereço é obrigatório",
				InitHourHigher: "O horário inicial não pode ser maior no horário final",
				ConfirmationMessage: "Mensagem de confirmação",
				AddressNotGeoRef: "O endereço não pôde ser georreferenciado confirme o seu endereço",
				AddressNotGeoRefSitidata:
					"Não foi possível georreferenciar o endereço, confirme seu endereço e verifique se o serviço de sitidata está habilitado",
			},
			GeoRef: {
				Finded: "O georreferenciador encontrou o seguinte endereço para as novas coordenadas:",
				UseVisitPoint: "Você quer usar este endereço para o ponto de visita?",
			},
		},
		Messages: {
			TitleConfirmCreate: "Depósito criado.",
			TextConfirmCreate: "O depósito foi criado com sucesso",
			TitleConfirmDelete: "Depósito Eliminado",
			TextConfirmDelete: "O depósito selecionado foi eliminado com sucesso",
			TitleConfirmUpdate: "Depósito atualizado",
			TextConfirmUpdate: "A equipe de depósito selecionada foi atualizada com sucesso",
			TextDelete: "Tem certeza de que deseja excluir o depósito? Aceite para continuar.",
			TextResources:
				"Lembre-se: Se você atribuir um recurso a este depósito e ele tiver sido atribuído a outro, o depósito anterior será substituído pelo atual.",
			DepositNotFound: "Depósito não encontrado",
			CountriesError: "Países não foram obtidos",
			DepartmentsError: "Estados não foram obtidos",
			CitiesError: "Cidades não foram obtidas",
			CityAndDirectionRequired: "Os campos de cidade e endereço são obrigatórios para georreferenciamento",
		},
		Labels: {
			StartInDeposit: "Começar em Depósito?",
			EndInDeposit: "Terminar no depósito?",
			Resource: "Recurso",
			Yes: "Sim",
		},
		Options: {
			StartAtDeposit: "Comece no depósito",
			EndAtDeposit: "Fim no depósito",
			NotStartAtDeposit: "Não começa no depósito",
			NotEndAtDeposit: "Não termina no depósito",
		},
	},
	// Status
	Status: {
		Title: "Status",
		ListOfStatus: "Lista de Status",
		CreateStatus: "Criar status",
		UpdateStatus: "Atualizar o status",
		AddNew: "Adicionar novo",
		Create: "Criar",
		Form: {
			ValidMessages: {
				Name: "O campo nome é obrigatório",
			},
		},
		Messages: {
			TitleConfirmCreate: "Criado.",
			TextConfirmCreate: "O status foi criado com sucesso",
			TitleConfirmDelete: "Removido",
			TextConfirmDelete: "O status selecionado foi removido com sucesso",
			TitleConfirmUpdate: "Atualizado",
			TextConfirmUpdate: "O status selecionado foi atualizado com sucesso",
			TextDelete: "Tem certeza de que deseja excluir o status selecionado? Aceite para continuar.",
		},
	},
	// Type Config
	TypeConfig: {
		Title: "Configuração de tipo",
		Create: "Criar novo tipo de configuração",
		Update: "Atualizar tipo de configuração",
		List: "Lista de tipo de configuração",
		New: "Configuração de Novo Tipo",
		AddNew: "Adicionar novo",
		Form: {
			Name: "Nome",
			Status: "Status",
			Field: "Campo",
			ValidMessages: {
				Name: "O campo nome é obrigatório",
				Status: "O campo de status é obrigatório",
				Complete: "Preencha o nome do campo",
			},
		},
		Messages: {
			TitleConfirmCreate: "Tipo de configuração criado.",
			TextConfirmCreate: "O tipo de configuração foi criado com sucesso",
			TitleConfirmDelete: "Tipo de configuração eliminado",
			TextConfirmDelete: "O tipo de configuração selecionado foi eliminado com sucesso",
			TitleConfirmUpdate: "Tipo de configuração atualizado",
			TextConfirmUpdate: "A equipe do tipo de configuração selecionada foi atualizada com sucesso",
			TextDelete: "Tem certeza de que deseja excluir o tipo de configuração? Aceite para continuar.",
			OneElement: "Você deve adicionar pelo menos 1 propriedade",
		},
	},
	//Tipology Module
	Tipology: "Tipologia",
	TextConfirmTipologyCreate: "Tipologia foi criada com sucesso",
	TextConfirmTipologyUpdate: "Tipologia foi atualizada com sucesso",
	TextConfirmTipologyDelete: "Tipologia foi excluída com sucesso",
	TitleConfirmTipologyCreate: "Tipologia criada",
	TitleConfirmTipologyUpdate: "Tipologia atualizada",
	TitleConfirmTipologyDelete: "Tipologia excluída",
	TextDeleteTipology: "Tem certeza que deseja deletar a tipologia",
	TextAccepContinue: "Por favor aceite para continuar",
	Save: "Salvar",
	Edit: "Editar",
	Remove: "Retirar",
	Add: "Adicionar",
	// Category Module
	Category: "Categoria",
	NewCategory: "Nova categoria",
	ListOfCategories: "Lista de categorias",
	TitleConfirmCategoryCreate: "Objeto criado",
	TitleConfirmCategoryUpdate: "Objeto atualizado",
	TitleConfirmCategoryDelete: "Objeto excluído",
	TextConfirmCategoryCreate: "O novo objeto foi criado com sucesso!",
	TextConfirmCategoryUpdate: "O objeto foi atualizado com sucesso!",
	TextConfirmCategoryDelete: "O objeto foi excluído com sucesso!",
	// Resources Module
	Resource: "Recurso",
	Resources: "Recursos",
	CreateResource: "Criar recurso",
	CreateFirstResource: "Criar o primeiro recurso",
	CreateObject: "Criar Objeto",
	ViewResource: "Veja o recurso",
	ResourceModule: {
		TotalCost: "Custo total",
		TotalResourcesSelected: "Total de recursos selecionados",
		UpdateResource: "Recurso de atualização",
		UserNotFound: "Usuário não encontrado",
		NewResource: "Adicionar Recurso",
		SelectTeamsResource: "Selecione as equipes do recurso",
		AssignedResources: "Recursos Atribuídos",
		AssigResources: "Atribuir Recursos",
		LoadListResources: "Carregue a lista de recursos a serem atribuídos ao capacities.",
		DeleteResource: "Eliminar Recurso",
		DeleteResources: "Deletar recursos",
		DeleteAllResources: "Deletar todos os recursos",
		NotResources: "Nenhum recurso atribuído",
		ResourceList: "Lista de Recursos",
		SelectedResourcesFrom: "Recursos selecionados de",
		ResourceSelectedFrom: "Recurso selecionado de",
		ShowOnlySelectedResources: "Mostrar apenas recursos selecionados",
		YouWantTheSelectedResourcesToBeRemoved:
			"o usuário deseja que os recursos selecionados sejam removidos do módulo de recursos no final do processo de importação",
		ResourceSelectionwillBecomeObsolete:
			"A seleção de recursos tornar-se-á obsoleta. Convidamo-lo a exportar os seus recursos executivos e de supervisão para o novo módulo de veículos",
		MassiveActionsResource:
			"Esta opção permite atualizar em massa o valor do campo de demanda nos recursos selecionados",
		BasicInfoForm: {
			ValidMessages: {
				Username: "O campo de nome de usuário é obrigatório",
				Identification: "O campo ID é obrigatório",
				Name: "O campo nome é obrigatório",
				LastName: "O campo do sobrenome é obrigatório",
				Role: "O campo de função é obrigatório",
				Status: "O campo de status é obrigatório",
				Email: "O campo do email é obrigatório e deve ser válido",
				Country: "O campo do país é obrigatório",
				Departament: "O campo do Estado é obrigatório",
				Address: "O campo de endereço é obrigatório",
				City: "O campo da cidade é obrigatório",
			},
			Messages: {
				NoCity: "A cidade não pode ficar vazia.",
				NoAddress: "O endereço não pode estar vazio.",
				SpecifyCity: "Especifique a cidade para melhor precisão.",
				AllFieldsRequired: "Todos os campos são necessários.",
				ClickGeoReference: "Você deve clicar no botão 'Georreferência'",
			},
		},
		CapacitiesActivities: {
			SubtitleActivities:
				"Atribua os horários de trabalho dos recursos, sua hora de início e sua hora de término do dia.",
			SubtitleCapacities: "Atribua os recursos do recurso atual.",
			Units: {
				Area: "Área",
				Volume: "Volume",
				Kilos: "Quilos",
				Weight: "Peso",
				Free: "Sem custos",
			},
			CapacityValidMessages: {
				Title: "Capacidade",
				Number: "O valor da capacidade deve ser de valor flutuante",
				Empty: "Insira o nome da habilidade",
				ScoreEmpty: "Insira o valor decimal para a capacidade",
				ThreeCapacities: "Você só pode inserir no máximo 3 recursos",
				SelectCapacity: "Selecione uma capacidade",
				EnterAmount: "Insira a quantidade",
			},
		},
		Skills: {
			Subtitle: "Selecione habilidades de recursos",
		},
		Breaks: {
			Subtitle: "Selecione quebras de recursos",
		},
		Deposits: {
			Subtitle: "Selecione um depósito para a rota inicial e final, para o recurso atual da lista acima. ",
			InitialResourceDepot: "Depósito inicial de recursos:",
			FinalResourceDepot: "Depósito final do recurso:",
		},
		AdditionalFields: {
			ValidCompleteValues: "Insira todos os valores nos campos",
		},
		Create: {
			FinalHour: "Hora de Fim",
			ValidEndHour: "O campo da hora final é obrigatório",
			InitialHour: "Hora inicial",
			ValidInitialHour: "O campo da hora inicial é obrigatório",
			Capacity: "Unidade",
			CapacityValue: "Quantia",
			KeyValue: "Valor chave",
			Label: "Rótulo",
			LabelMessage: "Etiqueta informativa para o usuário",
			Type: "Modelo",
			FieldValue: "Valor",
			SelectResource: "Selecione os recursos",
			Add: "Adicionar",
			Save: "Salvar",
			Clear: "Limpar",
			Action: "Açao",
			Delete: "Excluir",
			Next: "Próximo",
			Back: "Voltar",
			SuccessText: "Recurso Criado",
			Import: "Importar",
			ImportResources: "Importar recursos de dataRutas",
			DataRutasResourceSelected: "Recurso selecionado:",
			ResourcesNotAvailable: "Recursos não disponíveis no momento",
			MaxServiceTime: "Tempo Máximo de Serviço",
			MaxTravelDistance: "Distância máxima de viagem",
			Previous: "Anterior",
		},
		Edit: {
			PageTitle: "Editar Recurso",
			Title: "Editar Informação",
			Table: {
				Permissions: "Permissões",
				Module: "Módulo",
				Read: "Leitura",
				Write: "Escrever",
				Create: "Criar",
				Delete: "Excluir",
			},
			Save: "Salvar alterações",
			Success: {
				Title: "Sucesso",
				Text: "Recurso Atualizado",
			},
			Error: {
				Title: "Erro",
				Text: "As etapas 1 e 2 são obrigatórias.",
				Text2: "É obrigatório configurar a janela de tempo do recurso.",
				Email: "E-mail já registrado.",
				Id: "Identificação já cadastrada.",
				Username: "Nome de usuário já registrado.",
				Typology: "Selecione a tipologia",
				All: "Todos os campos são necessários",
				InitEndHoursReq: "Os horários inicial e final são obrigatórios.",
			},
		},
		Table: {
			Id: "Id",
			Username: "Nome do usuário",
			Name: "Nome",
			Lastname: "Último nome",
			Email: "O email",
			Role: "Função",
			Status: "Status",
			Actions: "Ações",
			Identification: "Identificação",
			Address: "Endereço",
			City: "Cidade",
			Department: "Estado",
			Delete: "Excluir",
			Search: "Procurar...",
			AdditionalFields: "Campos Adicionais",
			Team: "Equipo de Trabajo",
			Optimizer: "Otimizador",
			Company: "Empresa",
			Type: "Tipo",
			Errors: {
				ConsultResources: "Recursos não foram obtidos",
				ConsultResource: "Recurso não foi obtido",
				Delete: "O recurso não foi removido",
				ConsultSkills: "Obtendo as habilidades",
				ConsultTeams: "Obtendo as equipes",
				ConsultBreaks: "Obtendo as pausas",
				ConsultDepots: "Obtendo os depósitos",
			},
		},
		Messages: {
			TitleConfirmDelete: "Confirmar exclusão",
			TitleDeleted: "Recurso excluído",
			Delete: "Tem certeza de que deseja excluir o recurso:Tem certeza de que deseja excluir o recurso: ",
			Deleted: "O recurso foi excluído com sucesso.",
			AddProperties: {
				Success: {
					Title: "Campo agregado",
					Text: "O novo campo foi adicionado com sucesso",
				},
				Error: {
					Title: "Erro ao adicionar",
					Text1: "Não é possível adicionar se os campos e a etiqueta estiverem vazios",
					Text2: "Você não pode adicionar este campo, porque já existe um com o mesmo nome",
				},
			},
			RemoveProperties: {
				Title: "Campo excluído",
				Text: "O campo selecionado foi com sucesso removed",
			},
		},
		Title: {
			SkillsOptional: "Habilidades (opcional)",
			TeamsOptional: "Equipes (opcional)",
			BreaksOptional: "Pausas (opcional)",
		},
		Costs: {
			Subtitle: "Atribuir as variáveis de custos ao recurso atual.",
			"Fixed cost": "Custo fixo",
			"Cost per kilometer of the vehicle route": "Custo por quilômetro da rota",
			"Cost per hour of the vehicle route": "Custo por hora da rota do veículo",
			"Cost per traveled hour of the vehicle route": "Custo por hora percorrida da rota",
			KilometeOfTravel: "Quilómetro viagem",
			Fixed: "Fixo",
			RoutingTime: "Tempo de percurso",
			TimeTraveled: "Tempo percorrido",
		},
	},
	Routing: {
		Car: "Carro",
		Walker: "Andador",
		Walking: "A pé",
		Bicycle: "Bicicleta",
		Motorcycle: "Motocicleta",
		Truck: "Camião",
		Bus: "Autocarro",
		Scooter: "Lambreta",
		MaxDuration: "Duração máxima (min)",
		MaxDistanceSpeed: "Velocidade máxima (km / h)",
		YearsAgo: "{n} anos atrás ",
		YearAgo: "1 ano atrás",
		DaysAgo: "{n} dias atrás ",
		DayAgo: "1 dia atrás",
		HoursAgo: "{n} horas atrás ",
		HourAgo: "1 hora atrás",
		MinutesAgo: "{n} minutos atrás ",
		MinuteAgo: "1 minuto atrás",
		SecondsAgo: "{n} segundos atrás ",
		SecondAgo: "Agora mesmo",
		ROUTING_DONE: "Roteiro concluído",
		ROUTING_ERROR: "Erro com o roteiro",
		ROUTING_PROCESS: "Roteiro em andamento",
		Resource: "Recurso",
		Routing: "Pontos de visita da rota",
		Point: "Ponto",
		DistanceRoute: "Distância",
		MinimumRouteTime: "Tempo de rota",
		Typology: "Tipologia",
		SelectedColumns: "Colunas Selecionadas",
		ModuleNotEnabled: "Módulo não habilitado",
		SelectTypeRouter: "Selecione o modo de roteiro",
		VisitPointData: "Se o arquivo for carregado com os pontos de visita da Datarutas, ative a seguinte opção.",
		FromMapTitle: "Selecione um ponto no mapa clicando na posição desejada ou arrastando o marcador",
		FromMapAlert: "Selecione um ponto no mapa clicando na posição desejada",
		FromMap: "Habilita a função de poder selecionar um ponto do mapa clicando onde quiser",
		CreateRouting: "Criar roteiro",
		Optimizer: "Otimizador",
		TypesOfOptimization: "Tipos de otimização",
		ListOfRoutingTypes: "Lista de tipos de roteiro",
		FileUploadRouting: {
			Title: "File upload routing",
			Subtitle:
				"Permite selecionar um modo de roteiro (Roteiro Logístico, Roteiro Básico, Roteiro de Seleção, Roteiro de Datarutas) e, em seguida, carregar um arquivo com um problema de roteiro de veículos para obter a melhor rota.",
		},
		FileUploadOptimization: {
			Title: "Otimização de upload de arquivo",
			Subtitle:
				"Permite selecionar um tipo de roteiro (Roteiro Logístico, Roteiro Básico, Roteiro de Seleção, Roteiro Datarutas)",
		},
		CreateNewOptimization: {
			Title: "Criar nova otimização",
			Subtitle: "Permite criar uma nova otimização com pontos de visitas e recursos cadastrados na plataforma.",
		},
		DatarutasRouting: {
			Title: "Roteiro Datarutas",
			Subtitle:
				"O roteiro do Datarutas permitirá que você crie roteiros básicos com os pontos de visita do Datarutas.",
		},
		LogisticRouting: {
			Title: "Roteiro Logístico",
			Subtitle:
				"O roteiro logístico permitirá que você carregue um arquivo com clientes a visitar e veículos disponíveis considerando janelas de tempo e capacidade de entrega para o melhor trajeto.",
		},
		BasicRouting: {
			Title: "Roteiro Básico",
			Subtitle:
				"O roteiro básico nos dá uma rota ideal de acordo com a proximidade dos pontos por meio da API do Google Maps, com um sequenciamento ponto a ponto.",
		},
		RoutingBySelection: {
			Title: "Roteiro por Seleção",
			Subtitle:
				"O Roteiro por seleção permitirá que você faça uma seleção estratégica (concentração de pontos no mapa) de pontos de visita do mapa, previamente obtidos e localizados a partir de um arquivo de carregamento, uma fonte de dados de databilidade ou arquivos previamente cobrados.",
		},
		RoutingHistory: {
			Title: "Histórico de roteiro",
			Subtitle: "O histórico de roteiro, permite visualizar o roteiro realizado pelo usuário.",
			SubtitleView: "Veja as rotas carregadas pelo usuário.",
			NoResults: "Nenhum resultado foi encontrado, para criar seu primeiro clique na rota",
			Here: "aqui",
			Unauthorized: "Não autorizado",
			UnauthorizedRouting: "Nenhuma credencial válida para o roteador.",
			ErrorRoutingProcess: "Algo estava errado durante o processo de roteiro.",
			SuccessRoutingProcess: "Processo de roteiro concluído com sucesso.",
		},
		CreateVisitPoint: {
			ServiceTime: "Tempo de serviço",
			ValidServiceTime: "O campo de tempo de serviço é obrigatório",
			ReviewVisitPoints: "Rever pontos de visita",
			ConfigureActivityForAll: "Configurar atividade para todos",
			ConfigureActivityForAllText: "Você precisa definir uma atividade para todos os registros continuarem.",
			ExportDataRutasVisitPoint: "Exportar pontos de visita DataRutas",
			BulkAssign: "Atribuição em massa",
			DragFiles: "Arraste seus arquivos aqui ou clique nesta área",
			DeleteAsk: "Tem certeza de que deseja excluir o arquivo?",
			Errors: {
				ValidateManually: "Validar manualmente",
				FindLagOptimizeAgain: "Encontramos algum atraso, clique em otimizar novamente",
				SelectActivity: "Selecione uma atividade",
				DeleteRoute: "A rota não foi removida",
				ErrorImporting: "Erro ao importar informação",
			},
			Success: {
				VisitPointValidate: "Validar Ponto de Visita",
				Proccesing: "Em processamento",
				NotifyRouteWillBeRouted: "Você será notificado quando o arquivo for completamente encaminhado",
				DeleteRoute: "A rota foi removida com sucesso",
			},
		},
		Buttons: {
			Process: "Processar Arquivo",
			Next: "Próximo",
			Optimize: "Otimize",
			Reoptimize: "Reotimizar",
			SeeRoute: "Ver Rota",
			Validate: "Validar",
			OtherFields: "Adicionar a outros campos",
			AddVisitPoint: "Adicionar Ponto de Visita",
			EditVisitPoint: "Editar",
			NextResources: "A seguir, selecione os recursos",
			ExportRoute: "Rota de exportação",
			DownloadRoute: "Baixar rota",
			Downloading: "Baixando...",
			SeeAllRoutes: "Ver Rotas",
			Schedule: "Cronograma",
			DeleteRoute: "Eliminar rota",
			ReOptimizeRoutes: "Reotimizar rotas",
			Discard: "Descartar",
		},
		Table: {
			Type: "Modelo",
			Name: "Nome",
			AddedOn: "Adicionado",
			Action: "Açao",
			Actions: "Ações",
			Longitude: "Longitude",
			Latitude: "Latitude",
			EstimatedTimeArrival: "Tempo estimado de chegada",
			WaitingTime: "Tempo de espera",
			DistanceFromPrevious: "Distância parcial (km)",
			TotalDistanceTraveled: "Distância total percorrida (km)",
			EstimatedStartTask: "Tarefa de início estimada",
			EstimatedDepartureTime: "Hora estimada de partida",
			TimeService: "Tempo de serviço",
			TimeWindowInit: "Tempo inicial",
			TimeWindowEnd: "Fim do tempo",
			Cx: "Latitude",
			Cy: "Longitude",
			Demand: "Demanda",
			InitHour: "Hora inicial",
			EndHour: "Hora de Fim",
			Identification: "Identificação",
			Skills: "Habilidades",
			Row: "Excel Row",
			Column: "Coluna Excel",
			Error: "Erro",
			Break: "Descanso",
			Depot: "Depósito",
			Pickup: "Recogida",
			Delivery: "Entrega",
		},
		Title: {
			ResourceList: "Lista de Recursos",
			VisitPointsList: "Lista de pontos de visita",
			SelectFormat: "Selecione o formato",
			Close: "Fechar",
			MatchColumn: "Coluna de correspondência",
			TableExample: "Exemplo de dados de arquivo carregado",
			TableExampleText:
				"A continuación se muestra una previsualización de la rata encontrada en el archivo cargado",
			ProcessVisitPoints: "Pontos de visita de processo",
			EditVisitPoint: "Editar Ponto de Visita",
			VisitPoints: "Pontos de visita",
			VisitPointsDatarutas: "Pontos de visita Datarutas",
			VisitPointsLocations: "Locais dos pontos de visita",
			Resources: "Recursos",
			OptimizeByTeam: "Filtrar por equipe",
			SelectResource: "Selecione os recursos para exportar a rota",
			Errors: "Erros encontrados",
			UploadVisitpoints: "Carregar pontos de visita",
			UploadVisitpointsList: "Listar arquivos carregados",
			ExportFromDataRutas: "Exportar DataRutas de DataRutas",
			RoutingHistory: "Histórico de roteiro",
			Schedule: "Cronograma",
			RoutingMode: "Selecione o tipo de roteiro",
			RoutingType: "Select routing type",
			Basic: "Básico",
			Logistic: "Logística",
			Selection: "Seleção",
			AssignBulkActivity: "Atribuir atividade em massa",
			AssignActivity: "Atribuir atividade a todos os pontos de visita marcados.",
		},
		Map: {
			SeeMap: "Ver Mapa",
			ShowMap: "Mostrar Mapa",
			HideMap: "Esconder Mapa",
			MapAppearance: "Aspecto do mapa",
			Types: "Tipo de mapa",
			Styles: "Estilo de Mapa",
			ClickToDownload: "Clique para fazer o download",
			Coordinates: "Coordenadas",
			Georeference: "georeferenciação",
			Latitude: "Latitude",
			Longitude: "Longitude",
			GeoCoordinates: "Coordenadas geográficas",
			GeoreferencingByAddress:
				"Foi ativado o georreferenciamento por endereço para encontrar as coordenadas e localizá-las no mapa, você deve fazer",
			DiscardTheChanges: "Ou para descartar as alterações clique",
			CellAutoWith: "Largura Automática da Célula",
			ExportRoute: {
				Error: "A rota não pôde ser exportada",
				Success: "Rota exportada com sucesso",
				DownloadError: "Erro ao baixar o arquivo. Por favor, tente novamente.",
			},
			Schedule: {
				OptionalDate: "Data",
				ClickToSchedule: "Clique para agendar",
				Success: "Solicitação de agendamento enviada, para verificar usar o calendário Datarutas",
				Error: "Ocorreu um erro e sua programação não foi enviada",
				ErrorOptimization:
					"Ocorreu um erro na marcação de visitas, assinale a opção para o corrigir e voltar à ordem do dia",
				FoundErrors: "Algumas visitas não podem ser agendadas.",
				NotScheduledVisits: "Visitas não agendadas",
				ErrorResource:
					"Ocorreu um erro no agendamento das visitas. Os recursos destacados não foram encontrados no Datarutas.",
				SameDate:
					"Tentar agendar para o mesmo dia pode fazer com que algumas visitas não sejam agendadas, isso porque o DATARUTAS não permite que sejam agendadas visitas com data e horário inferior ao atual.",
				InitHourError: "A hora de início não pode ser menor que a hora atual",
				VisitpointError: "O ponto de visita selecionado não está atribuído ao recurso atual",
				ResourceActivityError: "A atividade selecionada não está atribuída ao recurso atual",
				WeAreGeneratingTheSchedule: "Estamos gerando a programação. Por favor, aguarde...",
			},
			VisitPoints: {
				Drop: "Ponto de visita de queda",
				Dropped: "Ponto de visita abandonado",
				Identifier: "Identificador",
				TimeArrival: "Tempo de chegada",
				Deposit: "Depósito",
			},
			DeleteRoute: {
				DeleteRouteAsk: "Tem certeza de que deseja excluir a rota atual?",
				Success: "Rota removida com sucesso",
			},
		},
		RouteResult: {
			Title: "Resultado da rota",
			ResourcesRouted: "Recursos Roteados",
			ResourcesNotRouted: "Recursos Não Roteados",
			RoutesTime: "Tempo mínimo total em todas as rotas",
			TotalDistance: "Distância total",
			VisitPointsRouted: "Pontos de visita roteados",
			VisitPointsNotRouted: "Pontos de visita não roteados",
			TotalResources: "Recursos totais",
			TotalVisitPoints: "Total de pontos de visita",
			TotalRoutings: "Total de Rotas",
			DrivingTimme: "Tempo de Condução",
			Load: "Carga",
			Capacities: "Capacidades",
			LoadCapacity: "Capacidade Carregada",
			SeeRoutes: "Ver Rotas",
			HideRoutes: "Ocultar rotas",
			HideRoute: "Esconder caminho",
			ChangeColorRoute: "Mude a cor da rota",
			Routes: "Rotas",
			RespectPlannedRoute:
				"Esta opção selecionada permite que o roteador honre a rota planejada ou então ele irá procurar uma nova rota durante a reotimização",
		},
		Messages: {
			MatchColumnSelectionRoutingP2Tooltip: "Mapeie as colunas do seu arquivo para os campos necessários",
			upload_placeholder: "Arraste seus arquivos aqui ou clique para adicionar um arquivo",
			MatchColumn:
				"Chaves e valores equivalentes aos nomes das colunas dados no arquivo a ser processado, para roteiro.",
			MatchColumnSelectionRouting:
				"Chaves e valores equivalentes aos nomes das colunas dados no arquivo a ser processado, para roteiro.",
			MatchColumnSelectionRoutingP2:
				"Selecione ao lado de cada título de coluna a coluna correspondente no arquivo a ser carregado.",
			MatchColumnSelectionRoutingP3:
				"A través da opção adicionar del listado, podemos agregar as colunas como valores adicionais ao resultado do processo de enrutamiento, o resto das colunas se omitirán.",
			MatchColumnSelectionRoutingP4:
				"Assim que o mapeamento for concluído, clique no botão Salvar para continuar sua seleção no mapa.",
			MatchColumnSelectionRoutingError: "As seguintes equivalências a serem atribuídas estavam faltando:",
			MatchColumnSelectionRoutingErrorTitle: "Erro de Equivalências",
			FileWithErrorsRoutingErrorTitle: "Arquivo contém erros",
			MatchColumnSelectionRoutingErrorEquivalents: "É necessário atribuir as equivalências das colunas",
			SelectedColumns:
				"Nomes de colunas que você deseja manter e que aparecem na resposta de roteiro; o restante dos campos será omitido.",
			ErrorMsg: "Corrija esses erros em seu arquivo Excel e tente carregá-lo novamente.",
			ErrorMsg2: "Corrija os erros mencionados anteriormente e tente enviar o arquivo novamente.",
			AlertRoutingHistory:
				'Lembre-se de que você pode reotimizar uma rota carregada anteriormente, usando a função "otimizar" e selecionando novos recursos.',
			AlertProccessing: "Estamos trabalhando para otimizar seu roteiro, avisaremos quando estiver concluído.",
			SelectSchedule: "Selecione seus recursos para agendar",
			DataRutasVisitPointsSelect:
				"Esta é a sua lista de pontos de visita no DataRutas, para rotear usando esses pontos, selecione-os e escolha um tipo de rota",
			AssignEquivalents: "Asignación Equivalencias De Columnas",
			Required: "Obrigatório",
			InformationFound: "Informação encontrada",
			ErrorsFound: "Erros encontrados durante o processo de upload de informações",
			ErrorsNotFound: "Nenhum erro encontrado durante o processo de upload de informações",
			ValidatorRequiredProperty: "Não é um valor válido",
			AlreadyRegistered: "Já registrado",
			DateLessThanCurrentDate: "Data anterior à data atual",
			NotRegistered: "Não registrado",
			ValidatorAdditionalProperties: "Propriedades adicionais não são permitidas, exclua-as",
			TooShortProperties: "O valor da propriedade está vazio ou o conteúdo é muito curto",
			TimeDataFormat: "O formato da hora não é válido, o formato correto da hora deve ser semelhante a HH:mm:ss",
			IsNotInteger: "Não é um número inteiro válido",
			InitHourWindowGreater: "A janela de tempo de início é maior do que a janela de tempo de término",
			ValidDemands: "Demandas nomes permitidos permitido na plataforma",
			DemandsInFile: "Nomes de demandas enviadas (cabeçalhos de arquivo)",
			InvalidDemands: "Reivindicações inválidas",
			InvalidDemandsNames:
				"Os nomes das demandas no arquivo (Nome do cabeçalho) não correspondem a nenhum nome de demanda permitido na plataforma. Por favor modifique os nomes dos cabeçalhos tendo em conta os nomes permitidos pela plataforma",
		},
		AssignColumns: {
			Text1: "O",
			Text2: "campo é obrigatório",
		},
		ValidateMessages: {
			Text: "Tem certeza de que deseja descartar as alterações feitas?",
			Yes: "Sim",
			Not: "Não",
		},
		HistoricalReOptimizationText:
			"A reotimização está sendo executada em segundo plano e a plataforma notificará você sobre seu status por meio do módulo de notificação",
		ValidateChangesReOptimize:
			"Você fez alterações para reotimizar a rota. Tem certeza de que deseja sair e descartar as alterações?",
	},
	// Divipola
	Divipola: {
		Country: "País",
		Department: "Estado",
		City: "Cidade",
		Address: "Endereço",
		GeoSearch: "Geo Search",
		GeoAgain: "Georreferenciamento Novamente",
		GeoSub: "Georreferenciar e localizar o endereço inserido no mapa.",
	},
	//
	Objects: "Objetos",
	NewObject: "Novo objeto",
	ListOfObjects: "Lista de objetos",
	TooltipSchemas: `El esquema define las propiedades mínimas que pueden tener objetos los dependiendo del tipo selecionado.`,
	Config: "Config",
	// VisitPoint
	VisitPoint: "Ponto de visita",
	CreateVisitPoint: "Roteador",
	// Activity
	Activity: "Atividade",
	ActivityList: "Lista de Atividades",
	CreateActivity: "Criar atividade",
	TitleConfirmActivityCreate: "Atividade criada",
	TextConfirmActivityCreate: "A atividade foi criada com sucesso",
	TitleConfirmActivityDelete: "Atividade excluída",
	TextConfirmActivityDelete: "A atividade selecionada foi excluída com sucesso",
	TitleConfirmActivityUpdate: "Atividade atualizada",
	TextConfirmActivityUpdate: "A atividade selecionada foi atualizada com sucesso",
	DeleteActivity: "Tem certeza que deseja excluir esta atividade? Por favor aceite para continuar",
	// Schedule
	TitleConfirmEventCreate: "Cronograma criado",
	TextConfirmEventCreate: "A programação foi criada com sucesso",
	TitleConfirmEventDelete: "Cronograma excluído",
	TextConfirmEventDelete: "A programação selecionada foi excluída com sucesso",
	TitleConfirmEventUpdate: "Cronograma atualizado",
	TextConfirmEventUpdate: "A programação selecionada foi atualizada com sucesso",
	DeleteEvent: "Tem certeza de que deseja excluir esta programação? Por favor aceite para continuar",
	PopupScheduleTitleCreate: "Criar nova programação",
	PopupScheduleTitleUpdate: "Cronograma de atualização",
	MODULE_ROLE: {
		Role: "Papel",
		Roles: "Papéis",
		Description: "Descrição",
		SelectRole: "Selecione uma função",
		Created: "Criado",
		Action: "Ações",
		RoleList: "Lista de funções",
		TitleCrear: "Criar papel",
		TitleUpdate: "Atualizar papel",
		ErrorName: "* Por favor, insira o nome da função",
		ErrorDescription: "* Por favor, insira o nome da papel",
		labelName: "Nome do papel",
		ValidName: "O campo do nome da função é obrigatório",
		labelAlias: "aliás",
		ValidAlias: "O campo alias é obrigatório",
		labelDescription: "Descrição",
		ValidDescription: "O campo de descrição é obrigatório",
		Cancel: "Cancelar",
		Ok: "Aceitar",
		Update: "Atualizar",
		Add: "Adicionar novo",
		titleDelete: "Excluir papel",
		msgDelete:
			"Isso pode entrar em conflito com usuários que têm essa função. Você deseja remover esta função mesmo assim?",
		Removed: "Removido",
		msgRemoved: "A função foi excluída com sucesso",
		Hecho: "Criado",
		msgHecho: "A função foi criada com sucesso",
		Change: "Atualizado",
		msgChange: "A função foi atualizada com sucesso",
		ErrorMessages: {
			ConsultRoles: "Consultando as funções",
			ConsultPermission: "Permissões de consultoria",
			ConsultRolePermissions: "Consultar as relações entre as funções e suas permissões",
			msgChange: "A função não foi atualizada",
			msgHecho: "A função não foi criada",
		},
		UpdateForm: "Formulário para editar uma função",
	},
	MODULE_PERMISSION: {
		Permissions: "Permissões",
		Role: "Permissão",
		Description: "Descrição",
		ListOfPermissions: "Lista de autorizações",
		Created: "Criado",
		Action: "Ações",
		TitleCrear: "Criar permissão",
		TitleUpdate: "Atualizar permissão",
		ErrorName: "* Por favor, insira o nome da licença",
		ErrorDescription: "* Por favor, insira uma descrição para permissão",
		labelName: "Nome de permissão",
		ValidName: "O nome do campo de permissão é obrigatório",
		labelDescription: "Descrição",
		ValidDescription: "O campo de descrição é obrigatório",
		labelRol: "Selecione as funções <b>(Opcional)</b>",
		Cancel: "Cancelar",
		Ok: "Aceitar",
		Create: "Criar",
		Update: "Atualizar",
		Add: "Crie um novo",
		titleDelete: "Permissão de exclusão",
		msgDelete:
			"Isso pode entrar em conflito com usuários que têm essa permissão. Quer remover esta permissão mesmo assim?",
		Removed: "Excluído",
		msgRemoved: "A permissão foi excluída com sucesso",
		Hecho: "Criado",
		msgHecho: "A permissão foi criada com sucesso",
		Change: "Atualizado",
		msgChange: "A permissão foi atualizada com sucesso",
	},
	MODULE_SOURCE: {
		Divider1: "Informação básica",
		Availability: "Disponibilidade",
		Divider2: "Atividades",
		Divider3: "Capacidades",
		Divider4: "Informações adicionais",
		Option: "*Opcional",
		legend1: "(você pode adicionar no máximo 3 capacidades)",
		Resource_type: "Tipo de recurso",
		id: "ID",
		names: "Nomes",
		lastName: "Último nome",
		Select_rol: "Selecione o papel",
		Select_status: "Selecione o status",
		User_name: "Nome do usuário",
		Email: "E-mail",
		Country: "País",
		Departament: "Estado",
		City: "Cidade",
		address: "Endereço",
		Completed: "Campo preenchido",
		Obligatory: "*Campo obrigatório",
		Costs: "Custos",
	},
	DrawingTools: {
		Tools: "Ferramentas",
		Circle: "Círculo",
		Polygon: "Polígono",
		Rectangle: "Retângulo",
		RemoveShape: "Remover forma",
		Selection: "Seleção",
		Polyline: "Polilinha",
		Help: "Ajuda",
	},
	RouterSelection: {
		RouterSelection: "Roteador por seleção",
		CheckedAll: "Verificar tudo",
		ActivityAssignment: "Atribuição de atividade",
		TotalVisitPointSelected: "Total de pontos de visita selecionados",
		AssignActivities: "Atribuir Atividades",
		ActivityAssignmentInfo: "É necessário atribuir uma atividade para continuar com o processo.",
		Activities: "Atividades",
		Activity: "Atividade",
		Total: "Total",
		TotalVisitPointInside: "encontrado dentro da área",
		TotalVisitPointInsideToContinue: "Por favor, selecione um ou mais pontos de visita para continuar.",
		TotalResourceInsideToContinue: "Selecione um ou mais recursos para continuar.",
		VisitPoints: "Pontos de visita",
		TitleConfirmRecordCreate: "Registro Criado",
		TextConfirmRecordCreate: "O registro foi criado com sucesso",
		TitleConfirmRecordDelete: "Registro excluído",
		TextConfirmRecordDelete: "O registro selecionado foi excluído com sucesso",
		TitleConfirmRecordUpdate: "Registro Atualizado",
		TextConfirmRecordUpdate: "O registro selecionado foi atualizado com sucesso",
		DeleteRecordTextConfirm: "Tem certeza que deseja deletar este registro? Por favor aceite para continuar",
		UpdateRecordTextConfirm: "Tem certeza de que deseja atualizar este registro? Por favor aceite para continuar",
		UpdateAllRecordTextConfirm:
			"Dependendo do total selecionado, a atualização de todos os registros selecionados pode demorar um pouco. Tem certeza que deseja continuar?",
		CleanMap: "Limpar mapa",
		validateStep1Error: "É necessário selecionar pontos de visita no mapa, para dar continuidade ao processo.",
		validateStep2Error: "É necessário selecionar recursos para dar continuidade ao processo.",
		validateStep3Error:
			"É necessário atribuir uma atividade a todos os pontos de visita para dar continuidade ao processo.",
		Step1Title: "Selecione os pontos de visita",
		Step2Title: "Selecione Recursos.",
		Step3Title: "Processo de execução",
		Hours: "Horas",
		Minutes: "Minutos",
		Seconds: "Segundos",
	},
	LoginModule: {
		CodeErrorGreater: "O campo do código não pode ter mais de 6 caracteres",
		CodeErrorToShort: "O campo do código deve ter pelo menos 6 caracteres",
		CodeErrorRquired: "O campo do código é obrigatório",
		CodeErrorAlphaNum: "O campo de código pode conter apenas caracteres alfanuméricos",
	},
	// Company Config Crud Module
	CompanyConfigCrud: "Configuração da Empresa",
	CompanyAddNewField: "Adicionar campo adicional",
	CompanyConfigCrudFormTitleCreate: "Formulário para criar uma configuração de empresa",
	CompanyConfigCrudFormTitleEdit: "Formulário para editar a configuração de uma empresa",
	CompanyConfNameAddLabel: "Nome do Campo",
	CompanyConfValueAddLabel: "Valor",
	CompanyConfNameAddValidMessage: "Apenas caracteres alfabéticos, sem espaços",
	CompanyConfValueAddValidMessage: "Por favor insira o valor aqui",
	DeleteCompanyConf: "Tem certeza de que deseja excluir esta empresa de configuração?",
	TitleConfirmCompanyConfigDelete: "Configuração da empresa excluída",
	TextConfirmCompanyConfigDelete: "A configuração selecionada foi excluída com sucesso",
	TitleConfirmCompanyConfigCreate: "Empresa de configuração criada",
	TextConfirmCompanyConfigCreate: "A configuração foi criada com sucesso",
	TitleConfirmCompanyConfigUpdate: "Configuração da empresa atualizada",
	TextConfirmCompanyConfigUpdate: "A configuração selecionada foi atualizada com sucesso",
	NewCompanyConfig: "Nova Configuração da Empresa",
	UpdateCompanyConfig: "Atualizar configuração da empresa",
	ListOfCompaniesConfig: "Lista de configuração de empresas",
	TitleWarningExistPropertyCompanyConfig: "Já existe",
	TextWarningExistPropertyCompanyConfig: "O valor a ser inserido já é",
	ListCompanyConfig: {
		TypeConfigName: "Nome do tipo de configuração",
	},
	ErrorFields: {
		Title: "Erro nos campos",
		Text: "Alguns campos estão faltando ou são inválidos!",
	},
	RoutingType: {
		Fleetrouting:
			"Ferramenta de otimização criada pelo Google, projetada para resolver os problemas mais difíceis de roteirização de veículos, fluxos, programação inteira e linear.",
		RutaOptima:
			"Default Route Optimizer criado por Servinformacion, baseado em OR-Tools, é um conjunto de ferramentas de código aberto.",
		OpenRoute: "Otimizador de rotas de código aberto.",
		AvailableRoutingTypes: "Roteiro Disponível",
		SelectRoutingType: "Selecione o tipo de roteiro",
		AskMeAgain: "Me pergunte de novo",
		SelectedRouter: "Roteiro seleccionado",
		RoutingType: "Tipo de roteiro",
		MaximizeWindow: "Maximizar janela",
		TourPlanning:
			"HERE Tour Planning, oferece passeios com custo ou tempo otimizados para todos os veículos de uma frota, incorporando o tipo e a capacidade do veículo, para maximizar a utilização. Otimização de veículos habilitada para tráfego ao vivo, usando atributos de caminhão quando apropriado.",
		SelectMeansTransport: "Selecione o seu meio de transporte",
		SelectMeansTransportText: "Que meio de transporte você vai usar para otimizar as rotas?",
		Transport: "Meio de transporte",
	},
	Login: {
		Subtitle: "Bem-vindo, faça o login para usar a plataforma.",
		Email: "Email",
		Password: "Contra-senha",
		Remember: "Lembre de mim",
		ForgotPassword: "Esqueceu sua senha?",
		Register: "Registro",
		Disabled: "A conta do usuário foi desabilitada por um administrador.",
		Login: "Conecte-se",
		ConnectingWithDatarutas: "Ligações com a Datarutas...",
		YouHaveSuccessfullyLoggedInToDatarutas:
			"Efectuou o login na Datarutas com sucesso! Agora pode continuar com as suas actividades",
		CouldNotConnectToDatarutas:
			"Não foi possível ligar à Datarutas. Por favor, verifique a sua ligação à Internet e tente novamente. Se o problema persistir, entre em contacto com o administrador da plataforma.",
		ValidMessages: {
			Email: "O campo Email é obrigatório e deve ser um email válido",
			Password: "A senha é obrigatória, mínimo de 6 caracteres - máximo de 18",
			InvalidPassword: "A senha é inválida ou o usuário não tem uma atribuída",
			UserNotFound: "Alguma coisa deu errado ao validar as credenciais",
			TooManyRequests:
				"O acesso a esta conta foi temporariamente desativado devido a muitas tentativas de login com falha. Você pode restaurá-la imediatamente redefinindo sua senha ou pode tentar novamente mais tarde.",
			CompanyReachedWorkingDate: "A empresa atingiu a data de trabalho",
			InvalidCode: "Código de autenticação inválido",
		},
		LoginWithGoogle: "Login com conta do Google",
		EnableTwoFactorAuthentication: "Habilitar autenticação de dois fatores",
		TwoFactorAuthentication: "Autenticação de dois fatores",
		TwoFactorAuthenticationText:
			"Digite o código de 6 dígitos que lhe foi enviado por e-mail para continuar com a autenticação",
		ResendAuthCodeEmail: "Se a mensagem com o código de autenticação não chegou, você pode solicitar um reenvio.",
		ResendCode: "Reenviar código",
		CodeSent: "Código de verificação enviado",
		CustomTokenMissing: "Token de autenticação não recebido. Por favor, faça login novamente.",
		FirebaseAuthError: "Erro ao autenticar com o Firebase.",
		Warning: "Aviso",
		ServerError: "Ocorreu um erro ao contatar o servidor.",
	},
	RecoverPassword: {
		Title: "Recuperar senha",
		Subtitle: "Insira seu endereço de e-mail e enviaremos instruções sobre como redefinir sua senha.",
		Email: "Email",
		ToLogin: "Entrar",
	},
	ResetPassword: {
		TitleReset: "Redefinir senha",
		TitleCreate: "Criar senha",
		Subtitle: "Por favor insira sua nova senha.",
		VerificationCode: {
			Title: "Código de verificação",
			Text1: "Um código de verificação foi enviado para o e-mail. se o código não chegar,",
			Text2: "mande de novo",
		},
		Code: "Código",
		YourPassword: "Sua senha",
		ConfirmPassword: "Confirme a Senha",
		ToLogin: "Entrar",
		Reset: "Redefinir",
		ValidPassword1: "O campo da senha deve ter pelo menos 6 caracteres",
	},
	Indicators: {
		Indicators: "Indicadores",
		IndicatorList: "Lista de Indicadores",
		CreateIndicator: "Criar Indicador",
		TitleConfirmIndicatorCreate: "Indicador Criado",
		TextConfirmIndicatorCreate: "O indicador foi criado com sucesso",
		TitleConfirmIndicatorDelete: "Indicador Excluído",
		TextConfirmIndicatorDelete: "O indicador selecionado foi excluído com sucesso",
		TitleConfirmIndicatorUpdate: "Indicador Atualizado",
		TextConfirmIndicatorUpdate: "O indicador selecionado foi atualizado com sucesso",
		DeleteIndicator: "Tem certeza que deseja excluir este indicador? Por favor aceite para continuar",
		UpdateIndicator: "Indicador de atualização",
		Visualizer: "Visualizar",
		AlertVisualizar: "Indicador do Visualizador",
		AlertVisualizarInfo: "Para ver um indicador, clique em um item da lista que você deseja ver.",
		IndicatorNotFound: "Não há indicadores ou não existe",
	},
	AssignedTeams: {
		Teams: "Equipes",
		TotalTeams: "Total de Equipes",
		Team: "Equipe",
		AssignedTeam: "Atribuir Equipe",
		AssignTeams: "Atribuir Equipes",
		AssignedTeams: "Equipes Atribuídos",
		AssignedTeamToltip: "Carregue a lista de equipes disponíveis para continuar com a atribuição.",
		ShowAssignedTeam: "Mostrar Equipes atribuídos",
		NoAssignedTeams: "Não há equipes atribuídos",
		ShowAssignedTeamToltip: "Mostra a lista dos equipes atribuídos.",
		AssignedTeamRequired: "A atribuição do Eeuipe é necessária",
		ClickOnButton: "Clique no botão",
		DeleteAllTeams: "Excluir todos os equipes",
		Colunms: "Colunas",
		ColumnsText: "Selecione as colunas que deseja renderizar na tabela",
	},
	VisitPoints: {
		CreateVisitPoint: "Criar ponto de visita",
		UpdatePointofVisit: "Atualizar ponto de visita",
		Add: "Adicionar",
		AddressCouldBeNotGeoreferenced: "O endereço não pôde ser georreferenciado",
		SitidataGeoreverseToken: "O token georeverso da API Sitidata não está habilitado para este país",
		SitidataNoEnabled: "SITIDATA API não habilitada para esta empresa.",
		Georeferencer: "Georreferenciador",
		Search: "Procurar",
		YouAreAboutToDeleteTheVisitPoint: "Você está prestes a excluir o registro com identificação",
		AllVisitPoints: "Todos os pontos de visita",
		ViewPointOfVisit: "Ponto de vista da visita",
		ListVisitPoint: "Lista de pontos de visita",
		Assig: "Atribuir",
		AssignVisitPoints: "Atribuir pontos de visita",
		AssignedVisitPoint: "Ponto de visita atribuído",
		AssignedVisitPoints: "Pontos de visita atribuídos",
		NoAssignedVisitPoints: "Não há pontos de visita atribuídos",
		AssigneVisitPointText: "Selecione os pontos de visita que você deseja atribuir.",
		AssignVisitPointToltip: "Carregue a lista de pontos de visita disponíveis para continuar com a atribuição.",
		AssignAllVisitPointText: "Atribuir todos os pontos de visita da plataforma",
		SelectObjectType: "Selecione o tipo de objeto",
		ObjectType: "Tipo de objeto",
		DeleteAllVisitPoints: "Exclua todos os pontos de visita.",
		DeleteAllText: "Você está prestes a deletar tudo",
		SelectedPointsOf: "Pontos selecionados de",
		SelectedPointOf: "Ponto selecionado de",
		ShowOnlySelectedVisitPoints: "Mostrar apenas os pontos de visita selecionados",
		SelectedInformation: "informações selecionadas",
		VisitingPointsSelected: "Pontos de visita selecionados",
		Demands: "Demandas",
		Location: "localização",
		MassiveActionsVisitPoints:
			"Esta opção permite atualizar massivamente os valores dos campos de procura e tipo de serviço nos pontos de visita selecionados",
		MakeMassiveSelectionFromPickupToDelivery:
			"Selecione massivamente os pontos de visita selecionados no serviço de entrega",
		MakeMassiveSelectionFromDeliveryToPickup:
			"Selecione massivamente os pontos de visita selecionados no serviço de recolha",
		FindAddress: {
			Title: "Direção encontrada",
			Text: "Endereço georreferenciado com sucesso.",
		},
		ErrorFindAddress: {
			Title: "Endereço não encontrado",
			Text: "O georreferenner não encontrou o endereço inserido",
		},
		MissingAddress: {
			Title: "Endereço é necessário",
			Text: "O endereço é exigido pelo georreferenciador.",
		},
		ErrorFindCountry: {
			Title: "Cobertura não encontrada",
			Text: "Verifique se o país escolhido corresponde ao país para onde você está arrastando o marcador",
		},
		Success: {
			Title: "Ponto de visita criado",
			Text: "Ponto de visita criado com sucesso",
		},
		EditSuccess: {
			Title: "Ponto de visita criado",
			Text: "Um novo ponto de visita foi criado.",
		},
		ErrorRegisterValidate: {
			Title: "Campos ausentes",
			Text: "Campos ausentes em informações adicionais",
		},
		ValidData: {
			Title: "Valide os dados",
			Text: "Faltando alguns campos importantes",
		},
		CellRenderer: {
			DeleteRecord: "Você está prestes a deletar",
			DeleteSuccess: {
				Title: "Ponto de visita excluído",
				Text: "O ponto de visita selecionado foi excluído com sucesso",
			},
		},
		VisitPointNotFound: {
			Title: "Ponto de visita não encontrado",
			Text1: "Registro de ponto de visita com id:",
			Text2: "não encontrado.",
		},
	},
	Group: {
		Group: "Grupo",
		Groups: "Grupos",
		AddGroup: "Adicionar grupo",
		CreateGroup: "Criar grupo",
		OptimizationGroup: "Grupo de Otimização",
		OptimizationGroups: "Grupos de otimização",
		ListOfOptimizationGroups: "Lista grupos de otimização",
		UpdateGroup: "Atualizar grupo",
		TotalOptimizations: "Não. Otimizações",
		TotalCreated: "Total Criado",
		TotalProcessed: "Total Processado",
		TotalFinalized: "Total Finalizado",
		TotalErrors: "Total de Erros",
		OptimizationsByGroup: "Optimizações por grupo",
		Messages: {
			Delete: "Tem certeza de remover a capacidade? Aceite para continuar",
			TitleConfirmDelete: "Grupo Eliminado",
			TextConfirmDelete: "O grupo selecionado foi excluído.",
			TitleConfirmCreate: "Grupo criado",
			TextConfirmCreate: "O grupo foi criado com sucesso",
			TitleConfirmUpdate: "Grupo atualizado",
			TextConfirmUpdate: "O grupo foi atualizado com sucesso",
			DeleteAll: "Tem certeza de que deseja remover todos os grupos da tabela?",
		},
		DeleteGroup: {
			Text1: "Tem certeza que deseja deletar o grupo",
			Text2: "Aceite para continuar.",
		},
		CellRenderer: {
			DeleteRecord: "Você está prestes a deletar",
			DeleteSuccess: {
				Title: "Grupo deletado",
				Text: "O grupo selecionado foi excluído com sucesso",
			},
		},
	},
	Optimization: {
		Optimization: "Otimização",
		Optimizations: "Otimizações",
		CreateOptimization: "Criar otimização",
		ListOptimizations: "Otimizações de lista",
		ListOfOptimizations: "Lista de otimizações",
		OptimizationHistory: "Histórico de otimização",
		ConfigurePeriod: "Configurar período",
		AcceptsNumbersLettersAndTheDashSign:
			"Insira um formato válido para o nome, lembrando que ele só aceita números, letras e o traço",
		Distance: "Distância",
		Fixed: "Fixo",
		Time: "Tempo",
		TraveledHour: "Hora percorrida",
		VehicleTime: "Tempo do veículo",
		OptimizationPeriod: "Período de otimização",
		TheProfileOfEachSelectedVehicle: "O perfil de cada veículo selecionado",
		OptimizationsFinished: "Optimizações concluídas",
		OptimizationsCreated: "Optimizações criadas",
		OptimizationsInProgress: "Optimizações em curso",
		OptimizationsWithErrors: "Optimizações com erros",
		OptimizationsPerRouter: "Optimizações por router",
		OptimizationsCompleted: "Optimizações concluídas",
		OptimizationsCompletedByRouter: "Optimizações concluídas pelo router",
		OptimizationProfileVehicleText:
			"Reveja os veículos seleccionados para otimização e certifique-se de que todos têm o perfil adequado antes de prosseguir. Se um veículo não tiver um perfil atribuído, será automaticamente aplicado o perfil padrão 'carro'.",
		ValidateOptimizationVisitpointText: "Para continuar é necessário adicionar no mínimo dois pontos de visita.",
		ValidateOptimizationResourceText: "Para continuar, você deve adicionar pelo menos um recurso.",
		TheUploadedFilesAreTemporaryForOptimization:
			"Os arquivos carregados são temporários para otimização e serão eliminados quando mudar para a opção de dados selecionada",
		OnlyMaximizeOrMinimizeTourCountAllowed:
			"Só é possível selecionar maximizar ou minimizar o número de tours ao mesmo tempo, não ambos ao mesmo tempo",
		DeleteOptimization: {
			Text1: "Tem certeza que deseja deletar o otimização",
			Text2: "Aceite para continuar.",
		},
		CellRenderer: {
			DeleteRecord: "Você está prestes a deletar",
			DeleteSuccess: {
				Title: "Otimização deletado",
				Text: "O otimização selecionado foi excluído com sucesso",
			},
		},
		Messages: {
			"is not valid": "This is not valid data",
			"the longitude coordinate is out of bounds": "A coordenada de longitude está fora dos limites",
			"the latitude coordinate is out of bounds": "A coordenada de latitude está fora dos limites",
			"the longitude coordinate is not valid": "A coordenada de longitude não é válida",
			"the latitude coordinate is not valid": "A coordenada de latitude não é válida",
			"minimum time_service 00:00:00": "Tempo mínimo_serviço 00:00:00",
			"Init hour window greater than end hour window": "Janela de hora inicial maior que a janela de hora final",
			"Init date/hour window outside of global window":
				"Janela de data/hora de inicialização fora da janela global",
			"End date/hour window outside of global window": "Janela de data/hora final fora da janela global",
			"Init hour window outside of global window": "Janela de hora de inicialização fora da janela global",
			"End hour window outside of global window": "Janela de horário de término fora da janela global",
			"Init date/hour break outside of vehicle time window":
				"Intervalo de data/hora de inicialização fora da janela de tempo do veículo",
			"End date/hour break outside of vehicle time window":
				"Data de término/hora do intervalo fora da janela de tempo do veículo",
			enum: "O valor não corresponde a nenhum dos valores permitidos na lista",
			type: "O tipo do valor não corresponde ao tipo especificado no esquema de dados",
			required: "Uma propriedade específica é necessária nos dados, mas está ausente",
			pattern: "O valor não atende ao padrão exigido no esquema de dados",
			format: "O valor não está de acordo com o formato especificado, como endereço de e-mail, URL, data, etc.",
			minimum: "O valor é menor que o valor mínimo permitido",
			maximum: "O valor é maior que o valor máximo permitido",
			minLength: "O comprimento do valor é menor que o comprimento mínimo permitido",
			maxLength: "O comprimento do valor é maior que o comprimento máximo permitido",
			minItems: "O número de itens em um array é menor que o número mínimo permitido",
			maxItems: "O número de elementos em um array é maior que o número máximo permitido",
			Unknown: "Ocorreu um erro desconhecido durante a otimização, inspecione error.serverResponse",
		},
	},
	RoutingTypeSearch: "Tipo de roteiro",
	VValidateMessage: {
		"The name field is required": "O campo nome é obrigatório",
		"Please enter your Skill name here": "O campo é obrigatório",
		"Please enter your break name here": "O campo é obrigatório",
		"Please enter your company name here": "O campo é obrigatório",
		"The name field may not be greater than 50 characters": "O campo de nome não pode ter mais de 50 caracteres.",
		"The name field may not be greater than 125 characters": "O campo de nome não pode ter mais de 125 caracteres.",
		"The name field may not be greater than 128 characters": "O campo de nome não pode ter mais de 128 caracteres.",
		"The name field may not be greater than 150 characters": "O campo de nome não pode ter mais de 150 caracteres.",
		"The description field may not be greater than 150 characters":
			"O campo de descrição não pode ter mais de 150 caracteres.",
		"The description field may not be greater than 250 characters":
			"O campo de descrição não pode ter mais de 250 caracteres.",
		"Please enter name here": "Por favor, insira o nome aqui",
	},
	TimeWindow: {
		TimeWindows: "Janelas de tempo",
		TimeWindow: "Janela de oportunidade",
		ListOfTimeWindows: "Lista de janelas de tempo",
		CreateTimeWindows: "Criar janelas de tempo",
		AddTimeWindows: "Adicionar janelas de tempo",
		Duration: "Duração",
		Daily: "Diária",
		Weekly: "Semanalmente",
		Monthly: "Por mês",
		Day: "Dia",
		Month: "Mês",
		Week: "Semana",
		Hours: "Horas",
		Minute: "Minuto",
		EveryDay: "Cada dia",
		Every: "Cada",
		FromThe: "A partir de",
		StartingAtMinute: "Começando no minuto",
		BetweenMinute: "Entre minuto",
		OfTheMonth: "Do mês",
		SpecificDayOfTheWeek: "Dia específico da semana (escolha um ou mais)",
		Programming: "Programação",
		SpecificDayOfTheMonth: "Dia específico do mês (escolha um ou mais)",
		EveryMonth: "Todo mês",
		MonthsStartingAtMonth: "Meses começando no mês",
		SpecificMonth: "Mês específico (escolha um ou vários)",
		EveryMonthBetween: "Todos os meses entre",
		And: "E",
		EveryHour: "Toda hora",
		HourStartingAtHour: "Hora começando na hora",
		SpecificHour: "Hora específica (escolha uma ou várias)",
		EveryHourBetweenHour: "A cada hora entre as horas",
		EveryMinute: "Todo minuto",
		MinuteStartingAtMinute: "Minuto começando no minuto",
		SpecificMinute: "Minuto específico (escolha um ou vários)",
		EveryMinuteBetweenMinute: "Cada minuto entre minuto",
		DayOfMonth: "Dia do mês",
		DayOfWeek: "Dia da semana",
		EveryDayBetween: "Todos os dias entre",
		TheChosenTimeIsNotValid: "O horário escolhido não é válido",
		Schedule: "Agendar",
		UpdateTimeWindow: "Atualizar janela de tempo",
		ViewTimeWindow: "Ver janela de tempo",
		AssignedTimeWindows: "Janelas de tempo atribuídas",
		AssignTimeWindows: "Atribuir janelas de tempo",
		AssignTimeWindowTooltip: "Carregue a lista de janelas de tempo disponíveis para continuar",
		DeleteAllTimeWindows: "Excluir todas as janelas de tempo.",
		NoAssignedTimeWindows: "Nenhuma janela de tempo atribuída",
		DeleteAllText: "Você está prestes a excluir todos",
		SoftTimeWindow: "Janelas de tempo flexíveis",
		PenaltyForAnticipation: "Sanção por antecipação",
		PenaltyForLateness: "Penalização por atraso",
		SelectTimeWindows: "Selecione janelas de tempo...",
		TheSumOfTheInitialDurationAndTheFinalDuration:
			"A soma da duração inicial e da duração final deve ser menor ou igual à duração total da janela de tempo",
		PleaseCompleteThegeneralTimeWindow:
			"Por favor, preencha primeiro os dados da janela horária geral antes de continuar.",
		ThisWillBeEliminatedSecondTimeWindow: "Este será removido se for adicionada uma segunda janela de tempo",
		DateAndTimeMustBeWithinTheGeneral: "A data e a hora devem estar dentro do intervalo da janela temporal geral",
		RemoveAllOtherTimeWindowsToEnable:
			"Remover todas as outras janelas de tempo para permitir a configuração de uma janela de tempo flexível.",
		ItIsNotPossibleToAddAnotherTimeWindow:
			"Não é possível adicionar outra janela de horário enquanto houver uma janela de horário flexível ativa. Por favor, exclua ou edite-a antes de continuar.",
		ThereAreCurrentlyNoTimeWindowsAvailable:
			"Atualmente, não existem janelas de tempo disponíveis na plataforma. Adicione uma nova janela utilizando o botão",
		AllDataRequestedAddedTimewindowAreRequired:
			"Todos os dados solicitados na janela de tempo adicionada são necessários para continuar",
		NameMonth: {
			January: "Enero",
			February: "Febrero",
			March: "Março",
			April: "abril",
			May: "Maio",
			June: "Júnio",
			July: "Júlio",
			August: "Agosto",
			September: "Septiembre",
			October: "Outubro",
			November: "Novembre",
			December: "Diciembre",
		},
		NameWeek: {
			Monday: "Segunda-feira",
			Tuesday: "Terça-feira",
			Wednesday: "Quarta-feira",
			Thursday: "Quinta-feira",
			Friday: "Sexta-feira",
			Saturday: "Sábado",
			Sunday: "Domingo",
		},
		DeleteTimeWindow: {
			Text1: "¿Tem certeza de que deseja remover a janela de tempo",
			Text2: "Aceite para continuar.",
		},
		CellRenderer: {
			DeleteRecord: "Você está prestes a deletar",
			DeleteSuccess: {
				Title: "Janela de tempo removida",
				Text: "A janela de tempo selecionada foi excluída com sucesso",
			},
		},
		Messages: {
			TitleConfirmCreate: "Janela de tempo criada",
			TextConfirmCreate: "A janela de tempo foi criada com sucesso",
			TitleConfirmUpdate: "Janela de tempo atualizada",
			TextConfirmUpdate: "A janela de tempo foi atualizada com sucesso",
		},
		TimeWindowNotFound: {
			Title: "Janela de tempo não encontrada",
			Text1: "Registro de janela de tempo com id:",
			Text2: "nao encontrado.",
		},
	},
	DesignConfig: {
		TypeField: "Campo Tipo",
		MinimumCharacterLength: "Comprimento mínimo de caracteres",
		MaximumCharacterLength: "Comprimento máximo de caracteres",
		MinimumVal: "Valor mínimo",
		MaximumVal: "Valor máximo",
		Option: "Opção",
		SwitchText: "Alternar Activo / Inactivo",
		SelectMinimumOneOption: "Selecione no mínimo uma opção",
		LoadOptions: "Carregar lista de opções",
		CalendarStatus: "Status do calendário",
		AllowValues: "Esta propriedade pode receber um dos seguintes valores",
		Date: "Data",
		DateTime: "Hora",
		Text: "Texto",
		Number: "Número",
		Email: "Email",
		Select: "Seleção",
		Url: "Url",
		File: "Arquivo",
		Image: "Imagem",
		Coordinates: "Coordenadas",
		DefaultLocation: "Localização padrão",
		Radio: "Várias opções",
		Checkbox: "Caixa de seleção",
		Dropdown: "Menu suspenso",
		Switch: "Boleano",
		Composed: "Composta",
		MultipleChoice: "Seleção múltipla",
		TypeConfig: "Tipo de Configuração",
		NewTypeConfig: "Novo tipo de configuração",
		NewTypeConfigRequired: "Tipo de configuração necessária",
		UpdateTypeConfig: "Atualizar tipo de configuração",
		ListOfTypeConfig: "Lista de tipos de configuração",
		InputNameTypeConfig: "Digite o nome",
		ButtonAddTypeConfig: "Adicionar",
		TitleConfirmTypeConfigUpdate: "Configuração de tipo modificada",
		TextConfirmTypeConfigUpdate: "O tipo de configuração selecionado foi modificado com sucesso",
		TypeConfigCrudFormTitleCreate: "Formulário para criar um tipo de configuração",
		TypeConfigCrudFormTitleEdit: "Formulário para editar um tipo de configuração",
		TitleSuccessTypeConfigCreated: "Configuração de tipo criada",
		TextSuccessTypeConfigCreated: "O tipo de configuração foi criado com sucesso",
		TitleSuccessTypeConfigCreatedError: "Erro ao criar tipo de configuração",
		TextSuccessTypeConfigCreatedError: "O tipo de configuração não foi criado",
		DeleteTypeConf: "Tem certeza de que deseja excluir este tipo de configuração?",
		TypeConfigConfigName: "Digite o nome da configuração",
		TypeConfigStatus: "Status",
		TypeConfigAddDateOn: "Adicionado",
		Property: "Propriedade",
		ChangeName: "Mude o nome",
		DeleteField: {
			Text1: "Tem certeza de que deseja eliminar o campo",
			Text2: "Aceite para continuar.",
		},
		UserDeleted: {
			Title: "Usuário excluído",
			Text: "O usuário selecionado foi excluído com sucesso.",
		},
	},
	Setting: {
		Setting: "Ajustes",
		NewConfiguration: "Nova Configuração",
		VisualSetting: "Ajustes Visuais",
		ThemeColor: "Cor do Tema",
		NavbarColor: "Cor da barra de navegação",
		ConfirmSave: "¿Você quer salvar as alterações aplicadas?",
		Saved: "Alterações salvas com sucesso.",
		SelectCompany: "Selecione a empresa para configurar",
		AllowedLogo: "Arquivos de imagem permitidos JPG ou PNG. Tamanho máximo de 900kB",
		ImageNotAllowed: "Imagem não permitida",
		ChooseImage: "Coletar imagem",
		UploadImage: "Upload Imagen",
		DeleteImage: "¿Tem certeza de excluir a imagem?",
		ImagenUploaded: "A imagem foi enviada com sucesso",
		ValidatorRequiredProperty: "é uma propriedade obrigatória",
		TooShortProperties: "O valor da propriedade está vazio ou o conteúdo é muito curto",
		IsNotStringValid: "Não é uma string válida",
		IsGreaterThanMaximum: "É maior que o valor máximo permitido",
		IsLessThanMinimum: "É menor que o valor mínimo permitido",
		ReviewValues: "Revise os valores permitidos no módulo de tipos de configuração",
		IsTooLong: "A string de texto é muito longa",
		UnexpectedError: "Ocorreu um erro inesperado",
	},
	SessionApi: {
		SessionApi: "Sessão por API",
		AccessToken: "Token de acceso",
		ExpireDate: "Fecha de expiración",
		ExpireDateError: "La fecha de expiración del token no puede ser mayor a la fecha de operación de la empresa",
		GenerateAccessToken: "Crear nuevo token de acceso por API",
		NotFoundAccessToken: "La empresa no tiene token de accesos por API",
		Copy: "Copiar",
		Copied: "Copied",
		CopiedText: "Token copied to clipboard successfully",
		Messages: {
			TitleConfirmCreate: "Token criado",
			TextConfirmCreate: "O token foi criado com sucesso",
			TitleConfirmDelete: "Token removido",
			TextConfirmDelete: "O token selecionado foi removido com sucesso",
			TitleConfirmUpdate: "Token atualizado",
			TextConfirmUpdate: "O token selecionado foi atualizado com sucesso",
			DepositNotFound: "Token não encontrado",
		},
	},
	ErrorVariable: {
		Textvariable1: "O campo está ausente ou incorreto!",
	},
	Preferences: {
		Preferences: "Preferências",
		ListOfPreferences: "Lista de preferências",
		FilterSearchTitle: "Tipo de pesquisas",
		FilterSearchNote: "Só funciona ao pesquisar através de campos adicionais",
		FilterSearchText:
			"Permite determinar se a pesquisa de pontos de visita ou recursos é estritamente igual aos critérios especificados ou se a pesquisa leva em consideração coincidências",
		FindExactly: "Pesquisar por critérios exatos",
		FindCoincidence: "Encontrar por partida",
		NumberDays: "Número de dias",
		NotificationNumberDays:
			"Configure o número de dias anteriores a partir dos quais a plataforma carregará e exibirá notificações",
		NotificationNumber:
			"Defina o número máximo de notificações que podem ser exibidas desde a última notificação recebida",
		DeleteOldNotification:
			"Ao iniciar a plataforma, exclua automaticamente as notificações anteriores aos dias anteriores estabelecidas anteriormente",
		FilterSearchExactText:
			"A ativação da pesquisa por critérios exactos define a pesquisa na lista estritamente igual aos critérios especificados",
		AllowsFindExactly:
			"Permite definir se a pesquisa dos módulos seleccionados é estritamente igual aos critérios especificados",
	},
	UploadFiles: {
		UploadFile: "Fazer upload de arquivo",
		File: "Arquivo",
		UploadFiles: "Fazer upload de arquivos",
		UploadSuccess: "Sucesso no upload",
		UploadSuccessMessage: "O arquivo foi carregado com sucesso.",
		UploadingFile: "Carregando arquivo...",
		ProcessingFile: "Processando arquivo",
		Progress: "Progresso",
		Uploading: "Carregando",
		Complete: "Completo",
		SmartSuggestions: "Sugestões",
		ClickToSelect: "Clique sobre uma sugerencia para atribuí-la",
		Columns: "Colunas",
		Records: "Registros",
		NoColumnsAvailable: "Nenhuma coluna disponível",
		Mapping: "Mapeamento",
		Required: "Obrigatório",
		Optional: "Opcional",
		RequiredFields: "Campos requeridos",
		UploadSuccessful: "Upload bem-sucedido!",
		RedirectingToMapping: "Redirecionando para mapeamento de colunas...",
		PleaseWait: "Por favor, aguarde...",
		UploadError: "Erro de upload",
		UploadErrorMessage:
			"Ocorreu um erro durante o upload do arquivo, verifique se o arquivo possui a estrutura básica ou baixe os arquivos de exemplo",
		UploadType: "Tipo de upload",
		UploadTypeSelectToltip: "Define o tipo de upload do arquivo",
		UploadTypeObjectToltip:
			"Define a estrutura do arquivo a ser carregado levando em consideração seus campos adicionais.",
		UploadTypeCountryTooltip: "Selecione o país onde serão georreferenciados os pontos de visita a carregar.",
		FormatFile:
			"Selecione um arquivo de rotas para iniciar o processo, somente os seguintes formatos são permitidos: excel (.xlsx), json, csv and xml",
		SelectFile: "Selecione o arquivo",
		UploadFileDragAndDrop: "Arraste o arquivo aqui ou selecione",
		UploadSuccessTextAlert:
			"O arquivo foi carregado com sucesso e está sendo processado em segundo plano, verifique ou aguarde as notificações do sistema para saber o status do processo.",
		FileReadyToBeUploaded: "Arquivo pronto para ser carregado.",
		Details: "Detalhes",
		Size: "Tamanho",
		DownloadFailed: "Falha no download",
		DownloadFailedText: "Falha no download, arquivo não encontrado ou foi removido do servidor",
		FileNotFound: "Arquivo não encontrado",
		DownloadFormat: "Baixar arquivo básico",
		DownloadFormatText:
			"Baixe um arquivo base ou modelo no formato selecionado que contém a estrutura necessária para o tipo de upload selecionado",
		Format: "Formato",
		InvalidFormatFile: "Arquivo de formato inválido",
		ListOfUploadedFiles: "Lista de arquivos carregados",
		TitleConfirmDelete: "Ficheiro eliminado",
		InvalidFormatFileText:
			"Selecione um arquivo com o formato correto para continuar com o upload. Somente arquivos .xlsx, .xls, .csv, .txt, .json ou .xml são permitidos",
		LoadMassiveAssignmentUploadFileError: "O arquivo não tem um formato válido para carregar as informações",
		DeleteUploadFile: {
			Text1: "Tem a certeza de que pretende Eliminar o ficheiro",
			Text2: "Por favor, aceite para continuar",
		},
	},
	ManualData: {
		Required: "Obrigatório",
		InformationFound: "Informação encontrada",
		ErrorsFound: "Erros encontrados durante o processo de upload de informações",
		ErrorsNotFound: "Nenhum erro encontrado durante o processo de upload de informações",
		ValidatorRequiredProperty: "é uma propriedade obrigatória, remova-a",
		AlreadyRegistered: "Já registrado",
		DateLessThanCurrentDate: "Data anterior à data atual",
		NotRegistered: "Não registrado",
		ValidatorAdditionalProperties: "Propriedades adicionais não são permitidas, exclua-as",
		TooShortProperties: "O valor da propriedade está vazio ou o conteúdo é muito curto",
		country: "País",
		city: "Cidade",
		address: "Endereço",
		identification: "Identificação",
		phone: "Telefone",
		name: "Nome",
		cx: "CX",
		cy: "CY",
		date: "Date",
		ManageError: "Gerenciar erros",
		ProcessAgain: "Processo de novo",
		ProcessAgainText:
			"Reprocesse o arquivo; isso tentará criar novos registros no sistema, portanto, observe que os registros não devem existir.",
		ProcessAgainTextSuccess:
			"Reprocessar o arquivo está funcionando em segundo plano, verifique ou aguarde as notificações do sistema para saber o status do processo.",
		DownloadFile: "Fazer download do arquivo",
		Download: "Baixar",
		AddedOn: "Adicionado",
		PropertyError: "Erro na propriedade",
		ShowErrors: "Mostrar erros",
		FixErrorsHere: "Corrija os erros aqui",
		FixErrorsModule: "Corrigir erros no módulo",
		SaveChanges: "Salvar alterações",
		ActivityNotRegistered: "Atividade não registrada",
		EditAlertText:
			"Edite a propriedade selecionada, respeite seu formato e observe que alguns valores devem existir.",
		Property: "Propriedade",
		ResourceHasNoActivities: "O recurso não tem atividades",
		SaveRecordError: "Erro ao salvar registro",
		DaneCodeNotFound: "Código Dane não encontrado",
		DuplicateRecordInExcel: "Registro duplicado no excel",
		InitHourLessThanCurrentTime: "Hora inicial menor que a hora atual",
		ErrorEndHour: "Erro na hora de término",
		ErrorInitHour: "Erro na hora inicial",
		ErrorDate: "Erro na data",
		CoordinatesCouldBeNotFound: "Coordenadas não encontradas",
		AddressCouldBeNotGeoreferenced: "O endereço não pôde ser georreferenciado",
		TimeDataFormat:
			"O formato não é válido, o formato correto deve ser semelhante para data AAAA-mm-dd ou hora HH: mm: ss",
		SitidataGeoreverseToken: "O token georeverso da API Sitidata não está habilitado para este país",
		InvalidValue: "tem um valor inválido, apenas cadeias de caracteres são permitidas",
	},
	OptimizerManager: {
		ManageOptimizers: "Gerir optimizadores",
		CreateConfiguration: "Criar configuração",
		UpdateConfiguration: "Atualizar a configuração",
		PointsPerDay: "Pontos por dia",
		PointsPerMonth: "Pontos por mês",
		PointsPerWeek: "Pontos por semana",
		PointsTotal: "Total de pontos",
		PointsSubscriptionMonthly: "Pontos por suscripción mensal",
		EnableOptimizationByTheWebPlatform: "Permitir a otimização pela plataforma Web",
		EnableOptimizationByAPIConsumption: "Permitir a otimização por consumo de API",
		CreateOptimizerConfiguration: "Criar configuração do optimizador",
		Optimizers: "Optimizadores",
		OptimizerConfigurationList: "Lista de configurações do otimizador",
		optimizerCompanyRequiredText:
			"A empresa necessita da configuração de um optimizador de rotas específico, contacte o administrador da plataforma para a configuração",
		DeleteOptimizerManager: {
			Text1: "¿É certo que a configuração será eliminada com Id",
			Text2: "Aceitar para continuar.",
		},
		CellRenderer: {
			DeleteRecord: "Está prestes a eliminar",
			DeleteSuccess: {
				Title: "Configuração eliminada",
				Text: "A configuração selecionada foi eliminada com êxito",
			},
		},
		Success: {
			Title: "Configuração do optimizador criada",
			Text: "Configuração do optimizador criada com sucesso",
		},
		EditSuccess: {
			Title: "Configuração do optimizador actualizada",
			Text: "A configuração do optimizador foi actualizada com êxito",
		},
		ErrorMessage: {
			TheOptimizationApiAlreadyExistsForTheEnterprise: "a API de otimização já existe para a empresa",
			ApiKeyIsNotRequiredForThisOptimizationApi: "A chave da API não é necessária para esta API de otimização",
			NotAValidDate: "Não é uma data válida",
			DateLessThanCurrentDate: "Data inferior à data atual",
			ThePointsperdayFieldMustBe2147483647OrLess: "O campo pontos por dia deve ser 2147483647 ou inferior",
			ThePointsPerWeekFieldShouldBe2147483647OrLower:
				"O campo de pontos por semana deve ser 2147483647 ou inferior",
			ThePointsPerMonthFieldMustBe2147483647OrLower: "O campo de pontos por mês deve ser 2147483647 ou inferior",
			TheTotalPointsFieldMustBe2147483647OrLower: "O campo do total de pontos deve ser 2147483647 ou inferior",
			TheTotalPointsFieldMustBe4294967295OrLower: "O valor inserido deve ser 4294967295 ou inferior",
			ThePointsSubscriptionMonthlyFieldMustBe2147483647OrLess:
				"O campo de pontos por suscripción mensual deve ser 2147483647 ou inferior",
			ThePointsSubscriptionMonthlyFieldMustBe4294967295OrLower:
				"O valor inserido deve ser 4294967295 ou inferior",
		},
	},
	Vehicles: {
		Vehicle: "Veículo",
		Vehicles: "Veículos",
		CreateVehicle: "Criar veículo",
		UpdateVehicle: "Atualizar veículo",
		YouAreAboutToDeleteTheVehicle: "Está prestes a eliminar o registo com o ID",
		AllVehicles: "Todos os veículos",
		ViewVehicles: "Ver veículo",
		ListOfVehicles: "Lista de veículos",
		AssignVehicles: "Atribuir veículos",
		AssignedVehicle: "Veículo atribuído",
		AssignedVehicles: "Veículos atribuídos",
		NoAssignedVehicles: "Nenhum veículo atribuído",
		AssigneVehicleText: "Seleccione os veículos que pretende atribuir",
		AssignVehicleToltip: "Carregue a lista de veículos disponíveis para continuar",
		AssignAllVehicleText: "Atribuir todos os veículos da plataforma",
		DeleteAllVehicles: "Eliminar todos os veículos",
		DeleteAllText: "Está prestes a Eliminar todos",
		SelectedPointsOf: "Veículos seleccionados de",
		SelectedPointOf: "Veículos seleccionados de",
		ShowOnlySelectedVehicles: "Mostrar apenas os veículos seleccionados",
		VehiclesPointsSelected: "Veículos seleccionados",
		Service: "Serviço",
		ImportResourcesToVehicles: "Importar recursos para veículos",
		ImportResources: "Importar recursos",
		ExportResourcesToVehicles: "Exportação de recursos para veículos",
		PermittedVehicles: "Veículos autorizados",
		CostPerVehicle: "Custo por veículo",
		CurrentlyThereAreNoVehiclesInTheSystem:
			"Atualmente, não existem veículos criados. Adicione um novo veículo utilizando a opção disponível",
		ThisListOnlyShowsSupervisoryAndExecutive:
			"Recursos das funções de supervisão e de execução não incluídos no módulo veículo",
		Success: {
			Title: "Veículo criado",
			Text: "Veículo criado com êxito",
		},
		EditSuccess: {
			Title: "Veículo atualizado",
			Text: "O veículo foi atualizado com êxito",
		},
		CellRenderer: {
			DeleteRecord: "Está prestes a eliminar",
			DeleteSuccess: {
				Title: "Veículo eliminado",
				Text: "O veículo selecionado foi eliminado com êxito",
			},
		},
		VehicletNotFound: {
			Title: "Veículo não encontrado",
			Text1: "Registo de veículo com id:",
			Text2: "não encontrado.",
		},
	},
	Record: {
		ListRecord: "Lista de Registros",
		RecordNumber: "Número recorde",
		UpdateRecord: "Atualizar registro",
		CreateRecord: "Criar registro",
		DeleteRecord: "Eliminar registro",
		DeleteRecordConfirmText: "Tem certeza de que deseja excluir este registro do sistema? Aceite para continuar.",
		TitleConfirmRecordCreate: "Registro Criado",
		TextConfirmRecordCreate: "O registro foi criado com sucesso",
		TitleConfirmRecordDelete: "Registro excluído",
		TextConfirmRecordDelete: "O registro selecionado foi excluído com sucesso",
		TitleConfirmRecordUpdate: "Registro Atualizado",
		TextConfirmRecordUpdate: "O registro selecionado foi atualizado com sucesso",
	},
	Frequency: {
		Frequency: "Frequência",
		Frequencies: "Frequências",
		ListOfFrequencies: "Lista de frequências",
		CreateFrequencies: "Criar frequências",
		AddFrequencies: "Adicionar frequências",
		UpdateFrequency: "Frequência de atualização",
		ViewFrequency: "Frequência de visualização",
		AssignedFrequencies: "Janelas de tempo atribuídas",
		AssignFrequencies: "Atribuir janelas de tempo",
		AssignFrequencyTooltip: "Carregar a lista de janelas de tempo disponíveis para continuar",
		DeleteAllFrequencies: "Eliminar todas as janelas de tempo.",
		NoAssignedFrequencies: "Não existem janelas de tempo atribuídas",
		ThereAreCurrentlyNoFrequenciesAvailable:
			"Atualmente, não existem frequências disponíveis na plataforma. Adicione uma nova frequência utilizando a opção",
		DiscardedItems: {
			Title: "Itens Descartados Devido a Frequências",
			Message: "Os seguintes itens foram descartados devido a conflitos de frequência:",
			Close: "Fechar",
			Pickup: "Coleta",
			Delivery: "Entrega",
			Vehicle: "Veículo",
			DiscardedDueToFrequencies: "descartado devido a frequências.",
			Showing: "Mostrando",
			of: "de",
			items: "itens",
		},
		Messages: {
			TitleConfirmCreate: "Frequência criada",
			TextConfirmCreate: "A frequência foi criada com êxito",
			TitleConfirmUpdate: "Frequência actualizada",
			TextConfirmUpdate: "A frequência foi actualizada com êxito",
		},
		DeleteFrequency: {
			Text1: "¿Tem a certeza de que pretende eliminar a frequência",
			Text2: "Por favor, aceite para continuar.",
		},
		CellRenderer: {
			DeleteRecord: "Está prestes a eliminar",
			DeleteSuccess: {
				Title: "Frequência eliminada",
				Text: "A frequência selecionada foi eliminada com êxito",
			},
		},
		FrequencyNotFound: {
			Title: "Frequência não encontrada",
			Text1: "Registo de frequência com id:",
			Text2: "não encontrado.",
		},
	},
	Jobs: {
		CreateJobPlanning: "Criar planejamento de trabalhos",
		SelectedJobs: "Trabalhos selecionados",
		JobPlanning: "Planejamento de trabalho",
		MaximumPickupDeliveryTime: "Duração máxima da coleta e da entrega",
		MaximumTimeOfAbsoluteDeviation: "Tempo máximo de desvio absoluto",
		RelativeDeviationLimit: "Limite de desvio relativo",
		PenaltyCost: "Custo da penalidade",
		ThisJobCannotBeAdded: "Esse trabalho não pode ser adicionado, pois já existe um com o mesmo nome",
		SpecifiesTheMaximumDuration:
			"Especifica a duração máxima do início da coleta até o início da entrega de um trabalho.",
		SpecifiesTheMaximumAbsolute:
			"Especifica o tempo máximo absoluto de desvio em comparação com o caminho mais curto entre a coleta e a entrega.",
		ToProceedYouMustAddAtLeast:
			"Para continuar, é necessário adicionar pelo menos um ponto de visita nos serviços de coleta e entrega",
		JobsAreUsedToAssociateADeliveryWithAPickup:
			"Os trabalhos são usados para associar uma entrega a uma coleta. Isso permite que o mesmo veículo realize as duas tarefas, otimizando rotas e recursos. Embora seja possível atribuir mais de uma entrega ou coleta a um único trabalho, essa flexibilidade permite que o otimizador escolha a melhor opção para realizar a coleta e/ou a entrega. No entanto, no resultado final, cada trabalho será configurado para lidar com apenas uma coleta e uma entrega.",
		AddJobsByFileUpload: "Adicionar trabalhos",
		JobsWereSuccessfullyAdded: "Os trabalhos foram adicionados com sucesso",
		AllowedJobFiles: "Arquivos de trabalhos permitidos",
		UploadedJobFile: "Arquivo carregado",
		MaximumFileSelectionForJobs: "A seleção máxima de arquivos para trabalhos foi atingida",
		CostPerVehicle: "Custo por veículo",
		CostPerVehicleColumnsRequired: "Você deve selecionar as colunas de identificação do veículo e custo",
		DownloadTemplate: "Baixar modelo XLSX",
		TemplateFileName: "modelo_trabalhos.xlsx",
		TemplateDownloadSuccess: "O modelo de trabalhos foi baixado com sucesso",
	},
	Territories: {
		Territories: "Territórios",
		Territory: "Território",
		TerritoryID: "ID do Território",
		TerritorySubtitle:
			"Visualize no mapa os territórios atribuídos às suas rotas. Cada território é representado por um polígono colorido que delimita sua área de cobertura e agrupa os pontos de visita associados. Esta funcionalidade permite identificar facilmente a distribuição dos seus pontos em campo.",
		VisualizeTerritoriesOnTheMap: "Visualizar territórios no mapa",
		ViewTerritories: "Ver Territórios",
		AllowOperationsOutsideTheAssignedArea: "Permitir operações fora da zona atribuída",
		TerritoryDoesNotHaveEnough:
			"O território {n} necessita de três ou mais pontos de visita para formar um polígono no mapa.",
	},
	AdvancedObjectives: {
		Objectives: "Objetivos",
		AdvancedObjectives: "Objetivos Avanzados",
		AdvancedObjectivesDescription:
			"Os objetivos avançados fornecem estratégias de otimização sofisticadas além dos objetivos básicos. Estes objetivos podem ser combinados para criar cenários de otimização complexos adaptados às necessidades específicas de cada negócio.",
		AdvancedObjectivesSaved: "Os objetivos avançados foram salvos com sucesso",
		ConfigureAdvancedObjectives: "Configurar objetivos avançados",
		AddObjective: "Adicionar objetivo",
		Objective: "Objetivo",
		ObjectiveType: "Tipo de objetivo",
		Configuration: "Configuração",
		SelectObjectiveType: "Selecionar tipo de objetivo",
		SelectObjective: "Selecionar objetivo",
		NoAdvancedObjectives: "Nenhum objetivo avançado",
		AddAdvancedObjectivesDescription: "Adicione objetivos avançados para personalizar a otimização de suas rotas.",
		MinimizeUnassigned: "Minimizar atribuições não realizadas",
		MinimizeUnassignedDescription: "Minimiza o número de pontos de visita não atribuídos.",
		EagerDelivery: "Entrega ágil",
		EagerDeliveryDescription:
			"Usado com o objetivo para minimizar custos para configurar o comportamento de entrega ágil",
		EnableEagerDelivery: "Habilitar entrega ágil",
		TieThreshold: "Limite de empate",
		ImprovementThreshold: "Limite de melhoria",
		MinimizeTours: "Minimizar tours",
		MaximizeTours: "Maximizar tours",
		MinimizeToursDescription: "Minimizar o número de tours/rotas",
		MaximizeToursDescription: "Maximizar o número de tours/rotas",
		MinimizeCostDescription: "Minimizar o custo total da solução",
		OptimizeTaskOrder: "Optimizar a ordem das tarefas",
		OptimizeTaskOrderDescription: "Optimizar a ordem das tarefas dentro das rotas",
		MinimizeDistance: "Minimizar distância",
		MinimizeDistanceDescription: "Minimizar a distância total percorrida",
		MinimizeDuration: "Minimizar duração",
		MinimizeDurationDescription: "Minimizar a duração total de todas as rotas",
		BalanceMaxLoad: "Balancear carga máxima",
		BalanceMaxLoadDescription: "Distribuir a carga máxima de forma equilibrada entre todos os veículos",
		BalanceActivities: "Balancear atividades",
		BalanceActivitiesDescription: "Balancear o número de atividades entre os veículos",
		BalanceDistance: "Balancear distância",
		BalanceDistanceDescription: "Balancear a distância percorrida entre os veículos",
		BalanceDuration: "Balancear duração",
		BalanceDurationDescription: "Balancear a duração das rotas entre os veículos",
		MaximizePriorityJobs: "Maximizar trabalhos de prioridade",
		MaximizePriorityJobsDescription: "Maximizar o número de trabalhos de prioridade servidos",
		MaximizeTerritoryJobs: "Maximizar trabalhos de território",
		MaximizeTerritoryJobsDescription: "Maximizar o número de trabalhos de território servidos",
		TourOrder: "Ordem de rota",
		TourOrderDescription: "Optimizar a ordem das visitas",
		OptimizeTaskPosition: "Optimizar a posição das tarefas",
		OptimizeTaskPositionDescription: "Optimizar a posição das tarefas dentro das rotas",
		VisuallyAppealingTours: "Visitas visualmente atractivas",
		VisuallyAppealingToursDescription: "Criar formas de rota visualmente atraentes",
		MinimizeTourOverlap: "Minimizar superposição de rotas",
		MinimizeTourOverlapDescription: "Minimizar a superposição entre diferentes rotas",
		ServeInClusters: "Servir em clusters",
		ServeInClustersDescription: "Atender pontos de visita em agrupamentos geográficos.",
		TieBreak: "Criterio de desempate",
		TieBreakDescription: "Resolver empates entre múltiplos objetivos",
		Threshold: "Umbral",
		BalanceThresholdDescription: "Limite para a otimização do equilíbrio",
		Weight: "Peso",
		WeightDescription: "Peso para a otimização do equilíbrio",
		IsConstrained: "Restringir",
		IsConstrainedDescription: "Restringir o objetivo a ser resolvido por um único objetivo",
		Tolerance: "Tolerância",
		ToleranceDescription: "Tolerância para a otimização do objetivo",
		MaxClusterRadius: "Raio máximo de cluster",
		MaxClusterRadiusDescription: "Raio máximo de cluster para a otimização do objetivo",
		TieBreakRules: "Regras de desempate",
		TieBreakRulesDescription: "Regras de desempate para a otimização do objetivo",
		ValidationError: "Erro de validação",
		AtLeastOneAdvancedObjectiveRequired: "Pelo menos um objetivo avançado é requerido",
		AllObjectivesMustHaveType: "Todos os objetivos devem ter um tipo selecionado",
		TieBreakMustHaveRules: "O objetivo de desempate deve ter pelo menos uma regra",
		TieBreakRulesMustHaveObjective: "As regras de desempate devem ter um objetivo selecionado",
	},
	FieldDescriptions: {
		identification: "Identificador único para cada registro",
		longitude: "Coordenada de longitude (formato decimal)",
		latitude: "Coordenada de latitude (formato decimal)",
		priority: "Nível de prioridade (número)",
		time_service: "Tempo de serviço em minutos",
		skills: "Habilidades requeridas (separadas por vírgulas)",
		demand: "Demanda ou capacidade requerida",
		allowed_vehicles: "Veículos permitidos",
		time_window: "Janelas de tempo disponíveis",
		additional_info: "Informação adicional",
		territory_id: "ID do território",
		profile: "Perfil do veículo",
		max_travel_distance: "Distância máxima de viagem",
		max_travel_duration: "Duração máxima de viagem",
		init_depot: "Depósito inicial",
		end_depot: "Depósito final",
		capacity: "Capacidade do veículo",
		breaks: "Descansos programados",
		time_cost: "Custo por tempo",
		traveled_hour_cost: "Custo por hora viajada",
		distance_cost: "Custo por distância",
		fixed_cost: "Custo fixo",
		strict_territories: "Territórios estritos",
		territories: "Territórios atribuídos",
		original_identification: "Identificador para agrupar registros",
		init_depot_id: "Coordenadas do depósito inicial",
		end_depot_id: "Coordenadas do depósito final",
		address: "Endereço",
		country: "País",
		status: "Estado",
		department: "Departamento",
		city: "Cidade",
	},
	FieldHints: {
		identification: "Exemplo: ID_001, VEH_001",
		longitude: "Exemplo: -74.0059",
		latitude: "Exemplo: 4.7110",
		priority: "Valores: 1 (alta) a 5 (baixa)",
		time_service: "Em minutos, exemplo: 30",
		skills: "Exemplo: refrigerado, pesado",
		demand: "Exemplo: 100, 2.5",
		time_window: "Horários de atenção",
		select_multiple: "Selecione colunas para {key}...",
		select_single: "Selecione coluna para {key}...",
	},
	FiltersAdvanced: {
		Title: "Painel de Filtros",
		BasicMode: "Básico",
		AdvancedMode: "Avançado",
		BasicModeTitle: "Filtros Simples",
		BasicModeDescription: "Filtros simples por campo e valor",
		AdvancedModeTitle: "Filtros Avançados",
		AdvancedModeDescription: "Filtros múltiplos com operadores lógicos e ordenação",
		SearchBy: "Pesquisar por:",
		SelectField: "Selecionar campo...",
		EnterValue: "Digite um valor...",
		Search: "Pesquisar",
		ClearFilters: "Limpar Filtros",
		FieldSelection: "Seleção de Campo",
		SelectFilterToAdd: "Selecionar filtro...",
		Add: "Adicionar",
		Clear: "Limpar",
		ActiveFilters: "Filtros Ativos",
		AddValue: "Adicionar valor...",
		NoFiltersAdded: "Nenhum filtro adicionado",
		SelectFieldAbove: "Selecione um campo acima para começar",
		FilterConfiguration: "Configuração de Filtros",
		LogicalOperator: "Operador Lógico",
		AND: "E (AND)",
		OR: "OU (OR)",
		MatchType: "Tipo de Coincidência",
		PartialMatch: "Coincidência Parcial",
		ExactMatch: "Coincidência Exata",
		Sorting: "Ordenação",
		ApplyFilters: "Aplicar filtros",
		Searching: "Pesquisando",
		SearchSuccess: "Pesquisa realizada com sucesso",
		SearchError: "Erro ao realizar a pesquisa",
		InvalidFilters: "Por favor complete todos os campos dos filtros",
		GroupPlaceholder: "Grupo (opcional)",
		NoGroup: "Nenhum grupo",
		AndGroup: "Grupo AND",
		OrGroup: "Grupo OR",
	},

	Wizard: {
		Previous: "Voltar",
		Next: "Avançar",
		Generate: "Gerar Clustering",
		Close: "Fechar",
		Finish: "Finalizar",
		StepIndicator: "Passo {current} de {total}",
		ValidationError: "Por favor complete todos os campos obrigatórios",
		Generating: "Gerando Clustering...",
		GeneratingMessage: "Por favor aguarde enquanto processamos seu clustering. Isso pode levar alguns momentos.",
		GenerateError: "Erro ao gerar clustering",
		ConfirmCancel: "Tem certeza que deseja cancelar? Todo o progresso será perdido.",
		Minimize: "Minimizar",
		Minimized: "Wizard minimizado. Você pode continuar interagindo com o mapa.",
		RestoreWizard: "Restaurar Wizard",
		ContinueCreating: "Continuar criando",

		// Common
		Recommended: "Recomendado",
		Easy: "Fácil",
		Optional: "Opcional",
		Available: "Disponíveis",
		Selected: "Selecionados",
		Loading: "Carregando",
		Success: "Sucesso",
		Instant: "Instantâneo",
		PointsAvailable: "pontos disponíveis",
		AdvancedFilters: "Filtros avançados",
		PreciseControl: "Controle preciso",
		LoadAndContinue: "Carregar e Continuar",
		ConfigureFilters: "Configurar Filtros",
		ShowPreview: "Ver Pré-visualização",
		HidePreview: "Ocultar Pré-visualização",
		ReloadPoints: "Recarregar Pontos",
		PointsPreview: "Pré-visualização de Pontos",
		ShowingFirst: "Mostrando os primeiros {count}",
		Of: "de",
		SearchByName: "Buscar por nome",
		SearchPoints: "Pesquisar pontos...",
		Show: "Exibir",
		Hide: "Ocultar",
		SelectFiltered: "Selecionar Filtrados",
		ClearSelection: "Limpar Seleção",
		StartDrawing: "Iniciar Desenho",
		FinishDrawing: "Finalizar Desenho",
		UndoLast: "Desfazer Último",
		ClearAll: "Limpar Tudo",
		PolygonsDrawn: "polígonos desenhados",
		PolygonRemoved: "Polígono Removido",
		LastPolygonRemoved: "O último polígono foi removido",
		ConfirmClearAllPolygons: "Remover todos os polígonos? Os pontos serão desmarcados.",
		AllPolygonsCleared: "Polígonos Removidos",
		PointsDeselected: "Todos os pontos foram desmarcados",
		ConfirmCreateAnother: "Deseja criar um novo clustering? Os dados atuais do wizard serão perdidos.",
		CreatingNew: "Iniciando novo wizard de clustering",
		ClickToAdd: "Clique para adicionar",
		ClickToRemove: "Clique para remover",
		SelectedPointsSummary: "Resumo de Pontos Selecionados",
		PolygonDrawingFinished: "{count} pontos selecionados com polígonos",
		SelectAll: "Selecionar Todos",
		DeselectAll: "Desmarcar Todos",
		PointsSelected: "Pontos selecionados",
		SelectionSummary: "Resumo de Seleção",
		EstimatedResult: "Resultado Estimado",
		PointsPerCluster: "Pontos por cluster",
		MicroClustersPerCluster: "Micro-clusters por cluster",
		DemandPerCluster: "Demanda por cluster",
		ShowingItems: "Mostrando {from}-{to} de {total}",
		SelectionComponentNotFound:
			"Não foi possível acessar o componente de seleção. Tente fechar e abrir o wizard novamente.",

		// Steps
		Steps: {
			Origin: {
				Title: "Origem dos Dados",
				Subtitle: "Carregar pontos de visita",
				MainTitle: "De onde vêm seus pontos de visita?",
				Description: "Escolha como deseja carregar os pontos que usará para o clustering",
				LoadAll: "Carregar Todos os Pontos",
				LoadAllDesc: "Opção rápida: carrega automaticamente todos os pontos de visita disponíveis no sistema",
				FilterFirst: "Filtrar Antes de Carregar",
				FilterFirstDesc:
					"Opção avançada: configure filtros específicos para carregar apenas os pontos que você precisa",
				SkipLoad: "Selecionar Pontos",
				SkipLoadDesc: "Acessar diretamente a tabela de pontos disponíveis e selecionar os que você precisa",
				SelectFromTable: "Selecionar da tabela",
				OrCreateManually: "Ou criar manualmente",
				ContinueToSelection: "Continuar para Seleção",
				SkipMessage: "Você pode selecionar pontos da tabela ou criá-los manualmente",
				PointsLoaded: "Pontos carregados com sucesso!",
				LoadedCount: "{count} pontos estão prontos para selecionar",
				ConfigureFilters: "Configurar Filtros Avançados",
				FilterHelp: "Use estes filtros para carregar apenas os pontos que atendam seus critérios",
				ConfirmReload: "Tem certeza que deseja recarregar os pontos? Isso removerá sua seleção atual.",
				LoadSuccess: "{count} pontos carregados com sucesso!",
				NoPoints: "Nenhum ponto de visita encontrado",
				LoadError: "Erro ao carregar os pontos de visita",
			},
			Selection: {
				Title: "Seleção",
				Subtitle: "Escolher pontos para clustering",
				MainTitle: "Selecione os pontos que deseja agrupar",
				Description: "Use o método que preferir para selecionar os pontos que farão parte do seu clustering",
				MinimumRequired: "Mínimo {min} pontos obrigatórios",
				MinimumRequiredPoint: "Mínimo 1 ponto obrigatório",
				FromTable: "Da Tabela",
				CreatePoint: "Criar Ponto",
				FromMap: "Do Mapa",
				Quick: "Rápido",
				SelectFromTable: "Selecionar da Tabela de Pontos",
				TableHelp:
					"Navegue, busque e selecione pontos diretamente da tabela. Você pode marcar múltiplos pontos de uma vez.",
				CreateNewPoint: "Criar Novo Ponto",
				CreateHelp:
					"Insira os dados manualmente para criar um novo ponto de visita. O ponto será adicionado automaticamente ao mapa e à sua seleção.",
				AddAndSelect: "Adicionar e Selecionar",
				ClearForm: "Limpar Formulário",
				PointsCreated: "Pontos Criados",
				PointCreated: "Ponto criado e adicionado com sucesso",
				PointRemoved: "Ponto removido",
				NoID: "Sem ID",
				SelectFromMap: "Selecionar do Mapa",
				MapHelp: "Use ferramentas de desenho ou clique diretamente nos pontos do mapa para selecioná-los",
				DrawPolygons: "Desenhar Polígonos",
				PolygonHelp: "Desenhe áreas no mapa para selecionar todos os pontos dentro delas",
				CreateByClick: "Criar Ponto com Clique",
				CreateByClickHelp: "Clique em qualquer parte do mapa para criar um novo ponto com essas coordenadas",
				StartClickCreate: "Ativar Criação",
				StopClickCreate: "Parar Criação",
				ClickCreateModeActive: "Modo de criação ativo. Clique no mapa para criar um novo ponto",
				EnterIdentification: "Identificação do Ponto",
				EnterIdentificationHelp: "Insira a identificação para o novo ponto",
				AddressFound: "Endereço encontrado",
				CoordinatesOnly: "Não foi possível obter endereço. Coordenadas",
				CreateCancelled: "Criação de ponto cancelada",
				PointCreatedFromMap: "Ponto '{identification}' criado do mapa",
				PointsCreatedByClick: "pontos criados",
				QuickSelection: "Seleção Rápida",
				QuickHelp: "Selecione ou desmarque todos os pontos com um único clique",
				SelectAllHelp: "Seleciona automaticamente todos os pontos carregados",
				ClearHelp: "Remove todos os pontos da seleção atual",
				FilteredSelected: "Pontos filtrados selecionados com sucesso",
				AllSelected: "Todos os pontos foram selecionados",
			},
			Demand: {
				Title: "Demanda",
				Subtitle: "Configurar capacidades",
				MainTitle: "Configure a demanda dos seus pontos",
				Description:
					"Atribua valores de demanda (capacidade necessária) aos pontos selecionados. Este passo é opcional mas recomendado para um clustering mais preciso.",
				Optional: "(Opcional mas recomendado)",
				QuickSetup: "Configuração Rápida",
				QuickHelp: "Aplica o mesmo valor de demanda a todos os pontos selecionados",
				IndividualEdit: "Edição Individual de Demandas",
			},
			Config: {
				Title: "Configuração",
				Subtitle: "Parâmetros do clustering",
				MainTitle: "Configure seu clustering",
				Description: "Defina o nome e parâmetros principais para gerar o clustering",
				Parameters: "Parâmetros do Clustering",
				NameHelp: "Escolha um nome descritivo que ajude a identificar este clustering",
				ClustersHelp: "Número de grupos principais que deseja criar (recomendado: 3-7)",
				ValidationError: "Por favor complete o nome do clustering",
			},
			Result: {
				Title: "Resultado",
				Subtitle: "Clustering gerado",
				Success: "Clustering Gerado com Sucesso!",
				SuccessMessage: "Seu clustering foi criado e está pronto para visualizar",
				NextSteps: "O que deseja fazer agora?",
				ActionsHelp: "Escolha uma ação para continuar trabalhando com seu clustering",
				CreateAnother: "Criar Outro Clustering",
				InfoTitle: "💡 Informação Útil",
				Info1: "As cores no mapa representam diferentes clusters",
				Info2: "Você pode visualizar clusters agrupados ou micro-clusters individuais",
				Info3: "Os resultados são salvos automaticamente na sua lista de clusters",
			},
		},
	},

	Clustering: {
		Title: "Agrupamento",
		Description: "Visualize, crie e gerencie clusters de pontos de visita",
		ControlPanel: "Painel de Controle",
		ClusterList: "Lista de Clusters",
		ClustersList: "Lista de Clusters",
		ClusterInfo: "Informação do Cluster",
		MicroClusterInfo: "Informação do Micro Cluster",
		ClusterSummary: "Resumo do Cluster",
		TotalDemand: "Demanda Total",
		AvgDemand: "Demanda Média",
		MicroClusterId: "ID do Micro Cluster",
		PointDetails: "Detalhes do Ponto",
		Statistics: "Estatísticas",
		TotalPoints: "Total de Pontos",
		BalanceMetrics: "Métricas de Equilíbrio",
		BalanceAnalysis: "Análise de Equilíbrio",
		AverageDemand: "Demanda Média",
		StandardDeviation: "Desvio Padrão",
		VariationCoefficient: "Coeficiente de Variação",
		Deviation: "Desvio",
		GeneralConfig: "Configuração Geral",
		DetailedConfig: "Configuração Detalhada",
		ClustersCreated: "Clusters Criados",
		MicroClusters: "Micro Clusters",
		MicroClustersPerCluster: "Micro Clusters por Cluster",
		Total: "Total",
		GeneratingConfig: "Gerando Configuração",
		EnableCapacities: "Habilitar Capacidades",
		Enabled: "Habilitado",
		Disabled: "Desabilitado",
		ExpandAll: "Expandir Tudo",
		CollapseAll: "Contraer Tudo",
		Of: "de",
		Balance: {
			Excellent: "Excelente",
			Good: "Bom",
			Fair: "Regular",
			Poor: "Baixo",
		},
		NoStatsAvailable: "Não há estatísticas disponíveis",
		ExportToExcel: "Exportar para Excel",
		ExportedSuccessfully: "Estatísticas exportadas corretamente",
		ExportError: "Erro ao exportar as estatísticas",
		NoDataToExport: "Não há dados para exportar",
		ExportingData: "Preparando exportação...",
		ViewingOnMap: "Mostrando clustering no mapa",
		OpeningList: "Abrindo lista de clusterings",
		ZoomTo: "Dar Zoom",
		FocusOn: "Focar",
		RemoveFocus: "Remover Foco",
		FocusedOn: "Focado em",
		Showing: "Mostrando",
		ShowingAll: "Mostrando todos os clusters",
		Highlight: "Destacar",
		Highlighted: "Destacado",
		ShowAll: "Mostrar Todos",
		Points: "Pontos",
		EnableHeatmap: "Ativar Mapa de Calor",
		DisableHeatmap: "Desativar Mapa de Calor",
		HeatmapEnabled: "Mapa de calor de demanda ativado",
		HeatmapDisabled: "Mapa de calor de demanda desativado",
		NoPointsInCluster: "Nenhum ponto encontrado neste cluster",
		ZoomedToCluster: "Vista ajustada ao cluster",
		Compactness: "Compacidade",
		AvgRadius: "Raio Médio",
		MaxDistance: "Distância Máxima",
		Area: "Área",
		Legend: "Legenda",
		PointTypes: "Tipos de Pontos",
		SelectedPoints: "Pontos Selecionados",
		UnselectedPoints: "Pontos Não Selecionados",
		ClusteredPoints: "Pontos Agrupados",
		Layers: "Camadas",
		ClusterPolygons: "Polígonos de Clusters",
		Heatmap: "Mapa de Calor",
		DemandIntensity: "Intensidade de Demanda",
		QuickActions: "Ações Rápidas",
		ViewMode: "Modo de Visualização",
		ViewClusters: "Clusters",
		ViewMicroClusters: "Micro Clusters",
		ViewStatistics: "Ver Estatísticas",
		ViewModeChanged: "Modo de visualização alterado",
		GroupedView: "Vista Agrupada",
		DetailedView: "Vista Detalhada",
		ViewClustersTooltip: "Ver clusters agrupados com seus micro-clusters",
		ViewMicroClustersTooltip: "Ver cada micro-cluster individualmente",
		ViewOnMap: "Ver no mapa",
		ViewClustersOnMap: "Ver no mapa os clusters",
		ViewMicroClustersOnMap: "Ver no mapa os micro clusters",
		ConfirmViewModeChange: "Confirmar Mudança de Modo",
		ViewModeChangeWarning:
			"Ao mudar o modo de visualização o mapa será limpo e todas as janelas serão fechadas. Deseja continuar?",
		ViewModeChangedSuccessfully: "Modo de visualização alterado com sucesso",
		CreatingCluster: "Criando Cluster",
		Processing: "Processando",
		CreatingClusterMessageBackground:
			"Estamos criando seu cluster em segundo plano. Isso pode levar alguns momentos. Enquanto espera, você pode continuar usando a plataforma normalmente.",
		// Points
		LoadedPoints: "Pontos Carregados",
		LoadPoints: "Carregar Pontos",
		LoadAllPoints: "Carregar Todos os Pontos",
		ManagePoints: "Gerenciar Pontos",
		PointManagement: "Gerenciamento de Pontos",
		CurrentPoints: "Pontos Atuais",
		Selected: "Selecionados",
		SelectExisting: "Selecionar Existentes",
		SelectAllVisible: "Selecionar todos visíveis",
		ClearSelection: "Limpar Seleção",
		ClearMap: "Limpar Mapa",
		MapCleared: "Mapa limpo com sucesso",
		AddPoints: "Adicionar Pontos",
		PointAlreadyExists: "Este ponto já existe na lista",
		NoPointsLoaded: "Não há pontos carregados. Use 'Gerenciar Pontos' ou 'Carregar Todos os Pontos' para começar.",
		TooManyPoints: "Muitos pontos (máximo 500). Por favor, filtre ou selecione menos pontos.",
		PointsLoaded: {
			Title: "Pontos Carregados",
			Text: "pontos carregados com sucesso",
		},
		NoPointsFound: {
			Title: "Sem Pontos",
			Text: "Nenhum ponto de visita disponível foi encontrado.",
		},
		ErrorLoadingPoints: "Erro ao carregar os pontos de visita",
		PointsSelected: {
			Title: "Pontos Selecionados",
			Text: "pontos selecionados no polígono",
		},
		NoPointsSelected: "Não há pontos selecionados. Desenhe um polígono no mapa primeiro.",
		SearchPoints: "Buscar pontos...",
		NoPointsMatch: "Nenhum ponto encontrado que corresponda à busca",

		// Point Creation
		AddOnMap: "Adicionar no Mapa",
		AddOnMapHelp: "Clique no mapa para criar um ponto",
		ManualForm: "Formulário Manual",
		ManualFormHelp: "Insira os dados manualmente",
		NewPoint: "Novo Ponto de Visita",
		Identification: "Identificação",
		IdentificationPlaceholder: "Ex: PONTO-001",
		Address: "Endereço",
		AddressPlaceholder: "Ex: Rua 72 #10-34",
		Latitude: "Latitude",
		Longitude: "Longitude",
		AddPoint: "Adicionar Ponto",
		MapClickInstructions: "Clique em qualquer parte do mapa para criar um novo ponto de visita",
		MapLoadError: "Não foi possível carregar o Google Maps. Por favor, recarregue a página.",

		// Summary Tab
		Summary: "Resumo",
		AddFirstPoint: "Adicionar Primeiro Ponto",
		ReadyForClustering: "Prontos para clustering",
		SelectedFromList: "Selecionados da Lista",
		CreatedManually: "Criados Manualmente",
		CreatedOnMap: "Criados no Mapa",
		EditPoint: "Editar Ponto",
		PointUpdated: "Ponto atualizado com sucesso",
		PointDeleted: "Ponto removido com sucesso",
		PointsDeleted: "{count} pontos removidos com sucesso",
		AllPointsDeleted: "Todos os pontos foram removidos",
		RemoveAllSelected: "Remover Todos os Selecionados",
		RemoveAllManual: "Remover Todos os Manuais",
		RemoveAllMapClick: "Remover Todos do Mapa",
		RemoveAllPoints: "Remover Todos os Pontos",
		ConfirmDeletePoint: "Tem certeza que deseja remover o ponto {point}?",
		ConfirmDeleteGroup: "Tem certeza que deseja remover {count} pontos de {group}?",
		ConfirmDeleteAll: "Tem certeza que deseja remover todos os {count} pontos? Esta ação não pode ser desfeita.",

		// Filters
		DemandRange: "Faixa de Demanda",

		// Demand Management
		DemandConfiguration: "Configuração de Demanda",
		DemandConfigHelp: "Configure a demanda (capacidade necessária) para cada ponto de visita",
		QuickDemand: "Demanda Rápida",
		Apply: "Aplicar",
		QuickDemandApplied: "Demanda rápida aplicada a todos os pontos",
		EditDemands: "Editar Individualmente",
		DemandEditor: "Editor de Demandas",
		GlobalDemand: "Demanda Global",
		GlobalDemandHelp:
			"Estabeleça uma demanda padrão para todos os pontos. Depois você pode personalizar cada ponto individualmente.",
		DefaultDemand: "Demanda Padrão",
		ApplyToAll: "Aplicar a Todos",
		DemandAppliedToAll: "Demanda aplicada a todos os pontos com sucesso",
		RandomDemands: "Demandas Aleatórias",
		ResetDemands: "Redefinir Demandas",
		ConfirmRandomDemands: "Deseja gerar demandas aleatórias (1-10) para todos os pontos?",
		RandomDemandsApplied: "Demandas aleatórias geradas com sucesso",
		ConfirmResetDemands: "Tem certeza que deseja redefinir todas as demandas para 0?",
		DemandsReset: "Todas as demandas foram redefinidas para 0",
		SaveDemands: "Salvar Demandas",
		DemandsSaved: "Demandas salvas com sucesso",
		PointsWithDemand: "Pontos com Demanda",
		DemandInfo:
			"A demanda representa a capacidade ou carga que cada ponto requer. Use 0 se você não precisar deste valor.",

		// Clustering
		CreateNew: "Criar Novo Clustering",
		Name: "Nome do Clustering",
		NamePlaceholder: "Ex: Bogotá Centro - Zona Norte",
		NameRequired: "O nome do clustering é obrigatório",
		NameTooLong: "O nome não pode exceder 125 caracteres",
		NameLength: "Caracteres",
		EditName: "Editar Nome do Clustering",
		Updated: "Clustering atualizado com sucesso",
		UpdateError: "Erro ao atualizar o clustering",
		FocusRemoved: "Foco removido com sucesso",
		TotalClusters: "Número de Clusters",
		Max10: "Máx: 10",
		MicroCluster: "Micro Cluster",
		MicroClustersHelp: "Subdivisões dentro de cada cluster (opcional)",
		Generate: "Gerar Clustering",
		Generating: "Gerando",
		GeneratedSuccess: "Clustering gerado com sucesso!",
		Reset: "Redefinir",
		ViewList: "Ver Lista",
		ViewAll: "Ver Todos",
		Cluster: "Cluster",
		Clusters: "Clusters",
		ClusterId: "ID do Cluster",
		Center: "Centro",
		Demand: "Demanda",
		Capacity: "Capacidade",
		Usage: "Uso",
		NoStatsFound: "Nenhuma estatística encontrada",
		ShowingItems: "Mostrando {start}-{end} de {total}",

		// Actions
		Regenerate: "Regenerar",
		ZoomToPoint: "Aproximar ao Ponto",
		SearchClusters: "Buscar clusters...",
		NoClustersFound: "Nenhum cluster encontrado",

		// Manual Selection & Point Selection
		ManualSelection: "Seleção Manual",
		ManualSelectionHelp: "Desenhe um polígono no mapa para selecionar pontos específicos",
		SelectionTools: "Ferramentas de Seleção",
		SelectionToolsHelp: "Selecione pontos usando múltiplos métodos",
		StartSelection: "Iniciar Seleção",
		CreateWithSelection: "Criar com Seleção",
		DrawPolygonHelp: "Desenhe múltiplos polígonos. Cada polígono adicionará pontos à seleção.",
		DrawPolygons: "Desenhar Polígonos",
		FinishDrawing: "Finalizar Desenho",
		RemoveLastPolygon: "Remover Último",
		ClearPolygons: "Limpar Polígonos",
		Polygons: "Polígonos",
		SelectPoints: "Selecionar Pontos",
		AvailablePoints: "Pontos Disponíveis",
		Available: "Disponíveis",
		SelectPointsToStart: "Selecione pontos para começar (polígono, clique ou seleção completa)",
		QuickSelection: "Seleção Rápida",
		SelectAll: "Selecionar Todos",
		DeselectAll: "Desmarcar Todos",
		ClickPointsHelp: "Clique nos pontos cinzas para adicioná-los ou nos verdes para removê-los",
		ViewSelected: "Ver Selecionados",
		PolygonMode: {
			Title: "Modo Polígono Ativado",
			Text: "Desenhe múltiplos polígonos para selecionar pontos. Clique em 'Finalizar' quando terminar.",
		},
		PolygonSelected: "Polígono Selecionado",
		PolygonSelectedHelp: "Clique duas vezes para remover ou use o botão vermelho",
		ConfirmRemovePolygon: "Remover este polígono? Os pontos dentro serão desmarcados.",
		DeletePolygon: "Remover Polígono",
		PolygonRemoved: "Polígono Removido",
		RemainingPolygons: "Polígonos Restantes",
		PointsAdded: {
			Title: "Pontos Adicionados",
			Text: "pontos adicionados à seleção",
		},
		PointAdded: {
			Title: "Ponto Adicionado",
			Text: "adicionado à seleção",
		},
		PointRemoved: {
			Title: "Ponto Removido",
			Text: "Ponto removido da seleção",
		},
		SelectionCleared: {
			Title: "Seleção Limpa",
			Text: "Todos os polígonos e a seleção foram removidos",
		},
		AllSelected: {
			Title: "Todos Selecionados",
			Text: "pontos selecionados",
		},
		AllDeselected: {
			Title: "Seleção Limpa",
			Text: "Todos os pontos foram desmarcados",
		},

		// Messages
		Success: {
			Title: "Clustering Criado",
			Text: "O clustering foi criado com sucesso",
		},
		Deleted: {
			Title: "Clustering Removido",
			Text: "O clustering foi removido com sucesso",
		},
		RegeneratedSuccess: "Clustering regenerado com sucesso",
		ValidationError: "Por favor complete todos os campos obrigatórios",
		PointsLimitExceeded: "Você excedeu o limite de 500 pontos",
		ErrorCreating: "Erro ao criar o clustering",
		ErrorLoadingList: "Erro ao carregar a lista de clusters",
		ErrorDeleting: "Erro ao remover o clustering",
		DemandDistribution: "Distribuição de Demanda",

		// Confirmations
		ConfirmDelete: "Tem certeza que deseja remover o clustering",
		ConfirmRegenerate: "Deseja regenerar o clustering",
		ConfirmReset:
			"Tem certeza que deseja redefinir o clustering atual? Você perderá todas as alterações não salvas.",

		// Loading messages
		Loaded: "Clustering carregado",
		ErrorLoading: "Erro ao carregar o clustering",
		ErrorDemandExceedsCapacity: "A demanda total {totalDemand} excede a capacidade total {totalCapacity}",
		SwitchedToClusters: "Alternado para visualização de Clusters",
		SwitchedToMicroClusters: "Alternado para visualização de Micro-clusters",

		// Validation
		validation: {
			name_required: "O nome do clustering é obrigatório",
			total_clusters_required: "Você deve especificar o número de clusters",
			total_clusters_max: "O número máximo de clusters é 10",
			points_required: "Você deve carregar pontos para criar um clustering",
			points_max: "O número máximo de pontos é 500",
		},
	},
};
